<template>
  <div>
    <div class="w-full">
      <!-- <v-overlay :value="isLoading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay> -->

      <v-row class="flex w-full">
        <!-- Left Panel - Question List with integrated previews -->
        <v-col
          class="coloms table-radius border border-[#e0e0e0]"
          cols="12"
          lg="7"
          v-if="categories.length > 0"
        >
          <v-card class="rounded-xl" flat>
            <v-card-text class="">
              <!-- <div class="flex justify-between items-center p-4 border-b border-gray-200">
                <h2 class="text-xl font-semibold text-gray-700">Forms</h2>
                <v-btn text color="primary" @click="addCategory">
                  <v-icon left>mdi-folder-plus</v-icon> Add Form
                </v-btn>
              </div>  -->

              <div class="p-4">
                <v-expansion-panels v-model="expandedCategory">
                  <v-expansion-panel
                    v-for="(category, index) in categories"
                    :key="getCategoryKey(category.categoryName)"
                    class="rounded-lg overflow-hidden mb-3"
                    :class="{ 'selected-category': expandedCategory === index }"
                  >
                    <v-expansion-panel-header class="category-header bg-gray-100 px-4 py-3">
                      <div class="flex justify-between items-center w-full">
                        <div class="flex items-center">
                          <div class="flex flex-col">
                            <span class="font-medium">{{ category.categoryName }}</span>
                            <span class="font-medium text-xs text-gray-500" v-if="category.formId"
                              >({{ category.formId }})
                              <v-btn
                                x-small
                                outlined
                                color="primary"
                                class="normal-case font-semibold"
                                @click.stop="copyFormId(category.formId)"
                                v-tooltip="{
                                  text: 'Copy FormId'
                                }"
                                >Copy FormId
                                <v-icon
                                  small
                                  color="primary"
                                  class="ml-2"
                                  v-tooltip="{
                                    text: 'Copy FormId'
                                  }"
                                  @click.stop="copyFormId(category.formId)"
                                  >mdi-content-copy</v-icon
                                >
                              </v-btn>
                            </span>
                            <span class="mt-1">
                              <v-chip
                                label
                                small
                                outlined
                                class="font-semibold"
                                :color="category.isPrivate ? 'red' : 'green'"
                              >
                                Form Access - {{ category.isPrivate ? 'Private' : 'Public' }}
                              </v-chip>
                              <v-btn
                                v-if="!category.specialCategory"
                                x-small
                                color="primary"
                                class="normal-case font-semibold ml-2"
                                @click.stop="
                                  copySpecificCategoryLink(category._id, category.categoryName)
                                "
                                v-tooltip="{
                                  text: 'Copy Share Link'
                                }"
                                >Copy Share Link
                                <v-icon small color="white" class="ml-2">mdi-content-copy</v-icon>
                              </v-btn>
                            </span>
                          </div>
                        </div>
                        <div class="ml-2 flex items-center justify-end">
                          <!-- will use this in the future to show the form connections -->
                          <!-- <div class="relative mr-2">

                            <v-btn
                              icon
                              small
                              @click.stop="showFormConnections(category)"
                              v-tooltip="{
                                text: 'View Connections'
                              }"
                            >
                              <v-icon small color="purple">mdi-connection</v-icon>
                            </v-btn>
                            <v-chip
                              v-if="getConnectionCount(category.formId) > 0"
                              x-small
                              color="purple"
                              text-color="white"
                              class="absolute -top-1 -right-1 connection-badge"
                            >
                              {{ getConnectionCount(category.formId) }}
                            </v-chip>
                          </div> -->
                          <span>
                            <v-chip
                              :color="extractFormType(category)?.color"
                              label
                              small
                              outlined
                              class="font-semibold"
                            >
                              {{ extractFormType(category)?.text }}
                            </v-chip>
                          </span>
                          <!-- </div>

                        <div> -->

                          <v-btn
                            v-if="!category.isPrivate && category.questions?.length > 0"
                            icon
                            class=""
                            @click.stop="openPopoverMenu(category._id, $event)"
                            v-tooltip="{
                              text: 'Share Social Link'
                            }"
                          >
                            <v-icon color="green">mdi-share-variant</v-icon>
                          </v-btn>
                          <PopOverMenu
                            :ref="`popoverMenu_${category._id}`"
                            :saveButtonText="'Send'"
                            :category-data="category"
                            :is-loading="sendingLinks[category._id]"
                            @savePopoverResponse="(data) => sendLinkToUser(data, category)"
                            @copyShareLink="
                              copySpecificCategoryLink(category._id, category.categoryName)
                            "
                            :fields="[
                              {
                                type: 'text',
                                key: 'to',
                                label: 'To (comma separated)',
                                icon: 'mdi-email',
                                value: ''
                              },
                              {
                                type: 'text',
                                label: 'Subject',
                                key: 'subject',
                                icon: 'mdi-pencil',
                                value: ''
                              },
                              {
                                type: 'editor',
                                label: 'Message Body',
                                key: 'messageBody',
                                icon: 'mdi-message',
                                value: ''
                              },
                              {
                                type: 'text',
                                label: 'Reminder Mails (comma separated)',
                                key: 'reminderMails',
                                icon: 'mdi-email-multiple',
                                value: ''
                              },
                              {
                                type: 'slider',
                                label: 'Expiry (Days)',
                                key: 'expiry',
                                min: 1,
                                max: 7,
                                value: 7
                              }
                            ]"
                          />
                          <v-btn
                            icon
                            class=""
                            @click.stop="editCategory(category.categoryName)"
                            v-tooltip="{
                              text: 'Edit Form'
                            }"
                          >
                            <v-icon color="blue">mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            @click.stop="deleteCategory(category.categoryName)"
                            v-tooltip="{
                              text: 'Delete Form'
                            }"
                          >
                            <v-icon color="red">mdi-delete</v-icon>
                          </v-btn>
                        </div>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="category-questions p-4 space-y-4">
                      <!-- Category Header with Banner and Logo -->
                      <div
                        v-if="category.images && category.images.length > 0"
                        class="mb-6 bg-white rounded-lg p-4 shadow-sm"
                      >
                        <div class="relative">
                          <!-- Banner -->
                          <div v-if="getCategoryBannerImage(category)" class="banner-container">
                            <img
                              :src="getCategoryBannerImage(category)"
                              class="w-full h-32 object-cover rounded-t-lg"
                              alt="Banner"
                            />
                          </div>

                          <div
                            class="flex items-center p-4"
                            :class="{
                              'absolute top-0 left-0 w-full': getCategoryBannerImage(category)
                            }"
                          >
                            <!-- Logo -->
                            <div v-if="getCategoryLogoImage(category)" class="mr-4">
                              <img
                                :src="getCategoryLogoImage(category)"
                                class="h-16 w-16 object-contain rounded-full bg-white p-1 shadow-sm"
                                alt="Logo"
                              />
                            </div>

                            <!-- Header -->
                            <h3
                              class="text-xl font-bold"
                              :class="{ 'text-white': getCategoryBannerImage(category) }"
                            >
                              {{ category.header }}
                            </h3>
                          </div>
                        </div>
                      </div>

                      <div
                        v-if="category.questions?.length === 0"
                        class="text-sm text-gray-500 p-4 text-center bg-white rounded-lg shadow-sm"
                      >
                        No questions in this category yet
                      </div>
                      <!-- <template v-if="category?.sections?.length > 0">
                        <div
                          v-for="(section, sectionIndex) in category.sections"
                          :key="sectionIndex"
                          class="mb-6 border border-gray-300 rounded-lg"
                        >
                          <div
                            class="bg-gray-100 p-3 rounded-t-lg font-medium border-b border-gray-300"
                          >
                            {{ section.sectionName }}
                          </div>
                          <div class="p-4">
                            <DraggableWrapper
                              :items="section.questions"
                              @reordered="(newOrder) => updateQuestionOrder(sectionIndex, newOrder)"
                              key-field="_id"
                            >
                              <template v-slot:default="{ item, index }">
                                <QuestionPreview
                                  :item="item"
                                  :get-type-color="getTypeColor"
                                  :get-type-icon="getTypeIcon"
                                  :banner-logo-url="bannerLogoUrl"
                                  :edit-question="
                                    () => editQuestion(category.categoryName, sectionIndex, index)
                                  "
                                  :delete-question="
                                    () => deleteQuestion(category.categoryName, index, sectionIndex)
                                  "
                                />
                              </template>
                            </DraggableWrapper>
                          </div>
                        </div>
                      </template> -->
                      <template>
                        <!-- Display questions directly (existing behavior) -->
                        <DraggableWrapper
                          :items="category?.questions"
                          @reordered="updateQuestionOrder"
                          key-field="_id"
                        >
                          <template v-slot:default="{ item, index }">
                            <QuestionPreview
                              :item="item"
                              :get-type-color="getTypeColor"
                              :get-type-icon="getTypeIcon"
                              :banner-logo-url="bannerLogoUrl"
                              :edit-question="() => editQuestion(category.categoryName, index)"
                              :delete-question="() => deleteQuestion(category.categoryName, index)"
                            />
                          </template>
                        </DraggableWrapper>
                      </template>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>

                <!-- Load More Button -->
                <div v-if="showLoadMoreButton" class="mt-6 text-center">
                  <v-btn
                    outlined
                    color="primary"
                    class="normal-case"
                    @click="loadMoreCategories"
                    :loading="isLoadingMore"
                    :disabled="isLoadingMore"
                  >
                    <v-icon left small>mdi-plus</v-icon>
                    Load More Forms
                    <span v-if="totalCount > 0" class="ml-2">
                      ({{ questionnaire.length }}/{{ totalCount }})
                    </span>
                  </v-btn>
                </div>

                <!-- Pagination Info -->
                <div v-if="totalCount > 0" class="mt-4 text-center text-sm text-gray-500">
                  Showing {{ questionnaire.length }} of {{ totalCount }} forms
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <div class="flex justify-center items-center py-32" lg="5" v-else>
          <NoData
            class="flex w-full justify-center"
            title="Nothing to Display"
            subTitle="Start by creating a form"
            btnText="Create Form"
            :btnAction="addCategory"
          />
        </div>

        <!-- Right Panel -Add Question Builder -->
        <v-col
          class="coloms table-radius border border-[#e0e0e0]"
          cols="12"
          lg="5"
          v-if="categories.length > 0"
        >
          <!-- <StickyWrapper :offsetTop="50"> -->
          <v-card class="rounded-xl position-relative" flat>
            <!-- Grey tint overlay when no category is selected -->
            <div>
              <div
                v-if="expandedCategory === null || expandedCategory === undefined"
                class="absolute inset-0 bg-gray-500 bg-opacity-50 z-10 flex items-center justify-center rounded-xl"
              >
                <div class="bg-white p-4 rounded-lg shadow-lg text-center">
                  <v-icon large color="info" class="mb-2">mdi-information-outline</v-icon>
                  <p class="text-lg font-medium">Please select a form</p>
                  <p class="text-sm text-gray-600">
                    Select a form from the left panel to add or edit questions
                  </p>
                </div>
              </div>

              <v-card-text class="">
                <div class="border-b border-gray-200 p-4">
                  <h2 class="text-xl font-semibold text-gray-700">
                    <!-- {{ editingQuestionId ? 'Edit Question' : 'Add Question' }} -->
                    Add Question to Selected Form
                    <span class="text-base text-gray-500" v-if="selectedFormId">
                      ({{ selectedFormId }})
                    </span>
                  </h2>
                </div>
                <div class="p-4">
                  <v-form ref="form">
                    <v-text-field
                      v-model="questionText"
                      label="Ask Question"
                      placeholder="Enter your question here"
                      outlined
                      dense
                      hide-details
                      class="mb-4"
                      :disabled="expandedCategory === null || expandedCategory === undefined"
                    ></v-text-field>

                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-1"
                        >Select Field Type
                      </label>
                      <div class="grid grid-cols-3 gap-3 mt-2">
                        <div
                          v-for="type in questionTypes.filter((t) => t.visible)"
                          :key="type.value"
                          @click="type.enabled && selectQuestionType(type.value)"
                        >
                          <div
                            class="question-type-selector p-3 border rounded-lg text-center"
                            :class="{
                              'border-blue-500 bg-blue-50': currentQuestionType === type.value
                            }"
                          >
                            <div
                              :class="{
                                'cursor-pointer': type.enabled,
                                'opacity-50 cursor-not-allowed': !type.enabled,
                                'flex items-center': true
                              }"
                            >
                              <v-icon
                                :color="type.enabled ? type.color : 'grey'"
                                class="mr-2 flex-shrink-0 items-center"
                              >
                                {{ type.icon }}
                              </v-icon>
                              <span class="whitespace-nowrap">{{ type.label }}</span>
                            </div>

                            <p
                              v-if="type.value === 'DATA_CATEGORY' && !type.enabled"
                              class="text-xs text-orange-600 mb-0 opa"
                            >
                              Already linked in this form.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Dynamic options based on question type -->
                    <div v-if="currentQuestionType" class="mt-4">
                      <div
                        v-if="
                          currentQuestionType === 'CHECKBOX' ||
                          currentQuestionType === 'RADIO' ||
                          currentQuestionType === 'SELECT_OPTIONS'
                        "
                        class="mb-4"
                      >
                        <label class="block text-sm font-medium text-gray-700 mb-2"
                          >{{ editingQuestionId ? 'Edit' : 'Add' }} Options</label
                        >
                        <div class="flex flex-col space-y-2">
                          <div
                            v-for="(option, index) in options"
                            :key="index"
                            class="flex items-center"
                          >
                            <div class="flex-grow p-2 bg-gray-50 border rounded-md">
                              {{ option }}
                            </div>
                            <v-btn icon small class="ml-2" @click="removeOption(index)">
                              <v-icon
                                small
                                color="red"
                                v-tooltip="{
                                  text: 'Delete Option'
                                }"
                                >mdi-delete</v-icon
                              >
                            </v-btn>
                          </div>
                        </div>

                        <div class="flex items-center mt-3">
                          <v-text-field
                            v-model="newOption"
                            label="Add new option"
                            placeholder="type and press enter"
                            outlined
                            dense
                            hide-details
                            class="flex-grow"
                            @keyup.enter="addOption"
                          ></v-text-field>
                          <v-btn color="primary" small class="ml-2" @click="addOption">
                            <v-icon small>mdi-plus</v-icon>
                          </v-btn>
                        </div>
                      </div>

                      <!-- Common options for all question types -->
                      <div class="flex flex-wrap items-center gap-4 mb-4">
                        <v-checkbox
                          v-model="isRequired"
                          label="Is this question mandatory to answer by user?"
                          hide-details
                          class="my-0 mr-4"
                        ></v-checkbox>

                        <v-text-field
                          v-if="currentQuestionType === 'LOCAL_ATTACHMENTS'"
                          v-model.number="maxAttachments"
                          type="number"
                          label="Max attachments"
                          min="1"
                          max="10"
                          outlined
                          dense
                          style="max-width: 250px"
                          hide-details
                        ></v-text-field>
                      </div>

                      <v-text-field
                        v-model="validationMessage"
                        label="Validation Message"
                        placeholder="Enter validation message"
                        outlined
                        dense
                        hide-details
                        class="mb-4"
                      ></v-text-field>

                      <!-- Media specific options -->
                      <div
                        v-if="
                          ['AUDIO_CAPTURE', 'VIDEO_CAPTURE', 'CLICK_PICTURES'].includes(
                            currentQuestionType
                          )
                        "
                        class="mb-4 flex justify-between items-center"
                      >
                        <v-text-field
                          v-model.number="mediaMaxSize"
                          type="number"
                          label="Maximum file size (MB)"
                          min="1"
                          max="100"
                          outlined
                          dense
                          class="mr-4"
                          style="max-width: 200px"
                        ></v-text-field>

                        <v-select
                          v-model="mediaQuality"
                          :items="['Low', 'Medium', 'High']"
                          label="Quality"
                          outlined
                          dense
                        ></v-select>
                      </div>

                      <!-- <div v-if="currentQuestionType === 'SERVICE_PLAN'" class="mb-4">
                        <label class="block text-sm font-medium text-gray-700 mb-2"
                          >Payment Plans</label
                        >
                        <div class="border border-gray-300 rounded-lg p-4">
                          <div
                            v-for="(plan, planIndex) in paymentPlans"
                            :key="planIndex"
                            class="mb-4 pb-4 border-b border-gray-200"
                          >

                            <div class="flex justify-between items-center mb-2">
                              <h4 class="font-medium">Plan #{{ planIndex + 1 }}</h4>
                              <v-btn icon small color="red" @click="removePaymentPlan(planIndex)">
                                <v-icon small>mdi-delete</v-icon>
                              </v-btn>
                            </div>
                            <v-text-field
                              v-model="plan.planName"
                              label="Plan Name"
                              placeholder="Enter plan name"
                              :rules="[(v) => !!v || 'Plan name is required']"
                              outlined
                              dense
                              hide-details
                              class="mb-2"
                            ></v-text-field>

                            <v-text-field
                              v-model="plan.planDescription"
                              label="Plan Description"
                              placeholder="Enter plan description"
                              outlined
                              dense
                              hide-details
                              class="mb-2"
                            ></v-text-field>

                            <div class="grid grid-cols-2 gap-4">
                              <v-text-field
                                v-model.number="plan.planDuration"
                                type="number"
                                label="Duration (days)"
                                min="1"
                                outlined
                                dense
                                hide-details
                              ></v-text-field>

                              <v-text-field
                                v-model.number="plan.planAmount"
                                :rules="[(v) => !!v || 'Amount is required']"
                                type="number"
                                label="Amount"
                                min="0"
                                outlined
                                dense
                                hide-details
                              ></v-text-field>
                            </div>
                  
                          </div>

                          <v-btn
                            color="primary"
                            text
                            block
                            @click="addPaymentPlan"
                            class="mt-2 normal-case"
                          >
                            <v-icon left>mdi-plus</v-icon> Add Plan
                          </v-btn>
                        </div>
                        <v-select
                          v-model="selectedPaymentType"
                          label="Payment Type"
                          :items="paymentTypes"
                          item-text="text"
                          item-value="value"
                          outlined
                          dense
                          hide-details
                          class="my-4"
                        ></v-select>
                        <div class="my-4" v-if="selectedPaymentType === 'QR_CODE'">
                          <label class="block text-sm font-medium text-gray-700 mb-2"
                            >Payment QR Code</label
                          >
                          <div
                            class="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center cursor-pointer relative"
                            @click="triggerFileInput('paymentQR')"
                          >
                            <div v-if="paymentQRImage">
                              <img
                                :src="paymentQRImage.preview"
                                class="mx-auto h-40 object-contain mb-2"
                              />
                              <v-btn
                                icon
                                small
                                class="absolute top-0 right-0 m-1"
                                @click.stop="removePaymentQR"
                              >
                                <v-icon small color="red">mdi-delete</v-icon>
                              </v-btn>
                            </div>
                            <div v-else>
                              <v-icon size="48" color="grey lighten-1">mdi-qrcode</v-icon>
                              <p class="text-sm text-gray-500 mt-1">Upload Payment QR Code</p>
                            </div>
                          </div>
                          <input
                            type="file"
                            ref="paymentQRInput"
                            class="hidden"
                            accept="image/*"
                            @change="handlePaymentQRUpload"
                          />
                        </div>


                        <div v-if="selectedPaymentType === 'PAYMENT_LINK'" class="mb-4">
                          <v-text-field
                            v-model="paymentLink"
                            label="Payment Link"
                            placeholder="Enter payment link"
                            outlined
                            dense
                            hide-details
                            class="mb-4"
                          ></v-text-field>
                        </div>

      
                        <div v-if="selectedPaymentType === 'GOOGLE_PAY'" class="mb-4">
                          <v-text-field
                            v-model="payment_UPI_Id"
                            label="UPI ID"
                            placeholder="Enter UPI ID"
                            outlined
                            dense
                            hide-details
                            class="mb-4"
                          ></v-text-field>
                        </div>
                      </div> -->

                      <!-- Data Category options -->
                      <div v-if="currentQuestionType === 'DATA_CATEGORY'" class="mt-4">
                        <label class="block text-sm font-medium text-gray-700 mb-2">
                          Available Data Categories
                        </label>
                        <div
                          v-if="dataCategories.length > 0"
                          class="border rounded-md p-3 bg-gray-50"
                        >
                          <div
                            v-for="(category, index) in dataCategories"
                            :key="index"
                            class="mb-2"
                          >
                            <v-chip class="mr-2 mb-2" small>{{ category.text }}</v-chip>
                          </div>
                        </div>
                        <div v-else class="text-sm text-gray-500 p-3 border rounded-md">
                          No data categories found for this license/team.
                          <span v-if="!selectedSubcase" class="text-blue-500"
                            >Please select a license/team first.</span
                          >
                        </div>
                        <p class="text-xs text-gray-500 mt-2">
                          These data categories will be available as options when this question is
                          displayed.
                        </p>
                      </div>
                    </div>
                    <v-divider
                      class="my-4"
                      v-if="selectedCategory && selectedCategory.specialCategory"
                    ></v-divider>

                    <!-- Predefined Sections Cards -->
                    <div class="mb-4" v-if="selectedCategory && selectedCategory.specialCategory">
                      <v-label class="text-base font-medium mb-2">Predefined Sections</v-label>
                      <div
                        class="mt-2"
                        @click="selectPredefinedSection(selectedCategory.specialCategory)"
                      >
                        <!-- Display only the selected predefined section -->
                        <div
                          class="pa-4 text-center cursor-pointer border border-blue-300 rounded transition-all duration-200 hover:shadow-lg hover:border-blue-500"
                          :class="{ 'elevation-2': selectedPredefinedSection }"
                        >
                          <v-card-text class="pa-2">
                            <div class="text-base font-medium">
                              {{ getSelectedPredefinedSectionText() }}
                            </div>
                          </v-card-text>
                        </div>
                      </div>
                    </div>

                    <v-label class="text-sm" v-if="selectedSubcase"
                      >Link this question to Field mapping in Linked UseCase</v-label
                    >
                    <v-select
                      v-model="linkedKey"
                      label="Link Question"
                      :items="fieldMappings"
                      placeholder="Link question with license column"
                      outlined
                      dense
                      hide-details
                      clearable
                      class="mt-2"
                      v-if="selectedSubcase"
                    ></v-select>
                  </v-form>
                </div>
              </v-card-text>
            </div>

            <div class="flex justify-end bg-white space-x-3 p-4 border-t border-gray-200">
              <v-btn
                text
                @click="showCopyQuestionsModal = true"
                outlined
                class="normal-case"
                small
                :disabled="
                  expandedCategory === null ||
                  expandedCategory === undefined ||
                  availableSourceCategories.length === 0
                "
                v-tooltip="{
                  text:
                    availableSourceCategories.length === 0
                      ? 'No other forms available to copy from'
                      : 'Copy questions from another form'
                }"
              >
                <v-icon left small>mdi-content-copy</v-icon>
                Copy Questions
              </v-btn>
              <div class="flex justify-end space-x-3">
                <v-btn text @click="resetQuestionForm" outlined class="normal-case" small
                  >Cancel</v-btn
                >
                <v-btn
                  small
                  color="primary"
                  @click="saveQuestion"
                  class="normal-case"
                  :disabled="isAddButtonEnable"
                  >{{ editingQuestionId ? 'Save' : 'Add' }}</v-btn
                >
              </div>
            </div>
          </v-card>
          <!-- </StickyWrapper> -->
        </v-col>
      </v-row>
    </div>

    <!-- Form Connections Modal -->
    <v-dialog v-model="showConnectionsModal" max-width="900px">
      <v-card class="rounded-lg">
        <v-card-title class="bg-purple-50 px-6 py-4">
          <div class="flex items-center justify-between w-full">
            <div class="flex items-center">
              <v-icon color="purple" class="mr-3">mdi-connection</v-icon>
              <div>
                <h3 class="text-lg font-semibold text-gray-800">Form Connections</h3>
                <p class="text-sm text-gray-600" v-if="selectedFormForConnections">
                  {{ selectedFormForConnections.categoryName }} ({{
                    selectedFormForConnections.formId
                  }})
                </p>
              </div>
            </div>
            <v-btn icon @click="showConnectionsModal = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>

        <v-card-text class="p-6">
          <div v-if="formConnections.length === 0" class="text-center py-8">
            <v-icon size="64" color="grey lighten-2">mdi-connection</v-icon>
            <p class="text-gray-500 mt-4">This form is not connected to any modules yet</p>
          </div>

          <div v-else class="space-y-4">
            <div
              v-for="(connection, index) in formConnections"
              :key="index"
              class="border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow"
            >
              <div class="flex items-start justify-between">
                <div class="flex items-start space-x-3">
                  <div class="flex-shrink-0">
                    <v-icon :color="connection.iconColor" size="24">{{ connection.icon }}</v-icon>
                  </div>
                  <div class="flex-grow">
                    <h4 class="font-medium text-gray-800">{{ connection.moduleName }}</h4>
                    <p class="text-sm text-gray-600 mt-1">{{ connection.description }}</p>

                    <!-- Connection Details -->
                    <div class="mt-3 space-y-2">
                      <div class="flex items-center text-xs text-gray-500">
                        <v-icon small class="mr-1">mdi-calendar</v-icon>
                        Connected on: {{ connection.connectedDate }}
                      </div>
                      <div class="flex items-center text-xs text-gray-500">
                        <v-icon small class="mr-1">mdi-account</v-icon>
                        Connected by: {{ connection.connectedBy }}
                      </div>
                      <div class="flex items-center text-xs text-gray-500">
                        <v-icon small class="mr-1">mdi-chart-line</v-icon>
                        Usage: {{ connection.usageCount }} submissions
                      </div>
                    </div>

                    <!-- Status Badge -->
                    <div class="mt-3">
                      <v-chip
                        :color="connection.status === 'active' ? 'green' : 'orange'"
                        small
                        text-color="white"
                      >
                        <v-icon small left>
                          {{
                            connection.status === 'active' ? 'mdi-check-circle' : 'mdi-pause-circle'
                          }}
                        </v-icon>
                        {{ connection.status === 'active' ? 'Active' : 'Inactive' }}
                      </v-chip>
                    </div>
                  </div>
                </div>

                <!-- Action Buttons -->
                <div class="flex flex-col space-y-2">
                  <v-btn
                    small
                    outlined
                    color="primary"
                    class="normal-case"
                    @click="viewConnectionDetails(connection)"
                  >
                    <v-icon small left>mdi-eye</v-icon>
                    View
                  </v-btn>
                  <v-btn
                    small
                    outlined
                    color="orange"
                    class="normal-case"
                    @click="editConnection(connection)"
                  >
                    <v-icon small left>mdi-pencil</v-icon>
                    Edit
                  </v-btn>
                  <v-btn
                    small
                    outlined
                    color="red"
                    class="normal-case"
                    @click="disconnectForm(connection)"
                  >
                    <v-icon small left>mdi-unlink</v-icon>
                    Disconnect
                  </v-btn>
                </div>
              </div>
            </div>
          </div>

          <!-- Add New Connection Button -->
          <div class="mt-6 pt-4 border-t border-gray-200">
            <v-btn
              color="primary"
              class="normal-case"
              outlined
              block
              @click="showAddConnectionModal = true"
            >
              <v-icon left>mdi-plus</v-icon>
              Connect to New Module
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Add Connection Modal -->
    <v-dialog v-model="showAddConnectionModal" max-width="600px">
      <v-card class="rounded-lg">
        <v-card-title class="bg-blue-50 px-6 py-4">
          <div class="flex items-center">
            <v-icon color="blue" class="mr-3">mdi-plus-circle</v-icon>
            <h3 class="text-lg font-semibold text-gray-800">Connect Form to Module</h3>
          </div>
        </v-card-title>

        <v-card-text class="p-6">
          <v-select
            v-model="selectedModuleToConnect"
            :items="availableModules"
            item-text="name"
            item-value="id"
            label="Select Module"
            outlined
            dense
            class="mb-4"
          >
            <template v-slot:item="{ item }">
              <div class="flex items-center py-2">
                <v-icon :color="item.iconColor" class="mr-3">{{ item.icon }}</v-icon>
                <div>
                  <div class="font-medium">{{ item.name }}</div>
                  <div class="text-sm text-gray-600">{{ item.description }}</div>
                </div>
              </div>
            </template>
          </v-select>

          <v-textarea
            v-model="connectionNotes"
            label="Connection Notes (Optional)"
            placeholder="Add any notes about this connection..."
            outlined
            dense
            rows="3"
            class="mb-4"
          ></v-textarea>
        </v-card-text>

        <v-card-actions class="px-6 pb-6">
          <v-spacer></v-spacer>
          <v-btn text @click="showAddConnectionModal = false" class="normal-case">Cancel</v-btn>
          <v-btn
            color="primary"
            class="normal-case"
            @click="connectFormToModule"
            :disabled="!selectedModuleToConnect"
          >
            Connect
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Add Category Modal -->
    <v-dialog v-model="showAddCategoryModal" max-width="800px" class="overflow-y-hidden">
      <div class="bg-white overflow-y-hidden">
        <div class="flex justify-between items-center border-b p-4 border-gray-200">
          <h3 class="form-title text-lg font-medium text-gray-900 pl-4">
            {{ editingCategoryName ? 'Edit' : 'Add New' }} Dynamic Form
          </h3>
          <v-btn icon @click="showAddCategoryModal = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <div class="">
          <v-alert type="info" class="text-sm" v-if="subcaseChangeinfo" text
            >Questions linked mappings will be reset if you change the license/team.</v-alert
          >
          <v-stepper
            v-model="categoryStep"
            vertical
            flat
            class="overflow-y-auto max-h-[calc(100vh-200px)]"
          >
            <!-- Step 1: Basic Information -->
            <v-stepper-step :complete="categoryStep > 1" step="1">
              Basic Information
            </v-stepper-step>
            <v-stepper-content step="1">
              <v-form>
                <v-text-field
                  v-model="newCategoryName"
                  label="Form Name"
                  placeholder="Enter form name"
                  outlined
                  hide-details
                  dense
                  :rules="[(v) => !!v || 'Form Name is required']"
                  class="my-4"
                ></v-text-field>
                <v-text-field
                  v-model="categoryHeader"
                  label="Tag Line"
                  placeholder="Enter tag line"
                  outlined
                  dense
                  hide-details
                  class="mb-4"
                ></v-text-field>

                <div class="grid grid-cols-2 gap-4 mb-4">
                  <div>
                    <label class="block text-sm text-gray-600 mb-1">Logo</label>
                    <div
                      class="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center cursor-pointer relative"
                      @click="triggerFileInput('logo')"
                    >
                      <div v-if="categoryImages.logo">
                        <img
                          :src="categoryImages.logo.preview"
                          class="mx-auto h-20 object-contain mb-2"
                        />
                        <v-btn
                          icon
                          small
                          class="absolute top-0 right-0 m-1"
                          @click.stop="removeImage('logo')"
                        >
                          <v-icon small color="red">mdi-delete</v-icon>
                        </v-btn>
                      </div>
                      <div v-else>
                        <v-icon size="36" color="grey lighten-1">mdi-image-outline</v-icon>
                        <p class="text-sm text-gray-500 mt-1">Upload Logo</p>
                      </div>
                    </div>
                    <input
                      type="file"
                      ref="logoInput"
                      class="hidden"
                      accept="image/*"
                      @change="handleImageUpload($event, 'logo')"
                    />
                  </div>

                  <div>
                    <label class="block text-sm text-gray-600 mb-1">Banner</label>
                    <div
                      class="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center cursor-pointer relative"
                      @click="triggerFileInput('banner')"
                    >
                      <div v-if="categoryImages.banner">
                        <img
                          :src="categoryImages.banner.preview"
                          class="mx-auto h-20 object-contain mb-2"
                        />
                        <v-btn
                          icon
                          small
                          class="absolute top-0 right-0 m-1"
                          @click.stop="removeImage('banner')"
                        >
                          <v-icon small color="red">mdi-delete</v-icon>
                        </v-btn>
                      </div>
                      <div v-else>
                        <v-icon size="36" color="grey lighten-1">mdi-image-outline</v-icon>
                        <p class="text-sm text-gray-500 mt-1">Upload Banner</p>
                      </div>
                    </div>
                    <input
                      type="file"
                      ref="bannerInput"
                      class="hidden"
                      accept="image/*"
                      @change="handleImageUpload($event, 'banner')"
                    />
                  </div>
                  <div class="flex flex-col">
                    <v-checkbox
                      v-model="isPrivate"
                      label="Private Access "
                      hide-details
                      dense
                      class="flex justify-start mt-4"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="isSpecialCategory"
                      label="Special Category Access"
                      hide-details
                      dense
                      class="flex justify-start mt-4"
                    ></v-checkbox>
                  </div>
                </div>
                <div class="flex justify-end mt-4">
                  <v-btn color="primary" @click="categoryStep = 2" class="normal-case" small
                    >Next</v-btn
                  >
                </div>
              </v-form>
            </v-stepper-content>
            <div v-if="isSpecialCategory">
              <!-- Step 2: License/Team Connection -->
              <v-stepper-step :complete="categoryStep > 2" step="2">
                Select Special Category Form Type
                <small>(Mandatory)</small>
              </v-stepper-step>
              <v-stepper-content step="2">
                <v-form>
                  <!-- <v-checkbox
                    v-model="linkWithSubLicense"
                    label="Do you want to link this form to any Use Case?"
                    class="ml-2"
                  ></v-checkbox> -->
                  <v-select
                    v-model="selectedSpecialCategory"
                    label="Select Special Category"
                    :items="specialCategories"
                    outlined
                    dense
                    hide-details
                    class="my-2"
                  ></v-select>

                  <div class="flex justify-end mt-4">
                    <v-btn text outlined small @click="categoryStep = 1" class="mr-4 normal-case"
                      >Previous</v-btn
                    >
                    <v-btn color="primary" @click="categoryStep = 3" class="normal-case" small
                      >Next</v-btn
                    >
                  </div>
                </v-form>
              </v-stepper-content>

              <!-- Step 3: Department /Designation Connection -->
              <v-stepper-step :complete="categoryStep > 3" step="3">
                Select Department/ Designation
                <small>(Optional)</small>
              </v-stepper-step>
              <v-stepper-content step="3">
                <v-form>
                  <v-checkbox
                    v-model="linkWithDesignation"
                    label="Do you want to link this form to any department/ designation?"
                    class="ml-2"
                  ></v-checkbox>
                  <v-select
                    v-if="linkWithDesignation"
                    v-model="selectedDepartment"
                    label="Select Department"
                    item-text="departmentName"
                    item-value="_id"
                    :items="departments"
                    outlined
                    dense
                    hide-details
                    class="my-2"
                    @change="fetchDesignationsByDepartment(selectedDepartment)"
                  ></v-select>
                  <v-select
                    v-if="linkWithDesignation"
                    v-model="selectedDesignation"
                    label="Select Designation"
                    :items="designations"
                    item-text="designationName"
                    item-value="_id"
                    outlined
                    dense
                    hide-details
                    class="my-2"
                    :disabled="!selectedDepartment"
                  ></v-select>

                  <div class="flex justify-end mt-4">
                    <v-btn text outlined small @click="categoryStep = 2" class="mr-4 normal-case"
                      >Previous</v-btn
                    >
                    <!-- <v-btn
                      color="primary"
                      @click="handleLicenseStepComplete"
                      class="normal-case"
                      small
                      >Next</v-btn
                    > -->
                  </div>
                </v-form>
              </v-stepper-content>
            </div>
            <div v-else>
              <!-- Step 2: License/Team Connection -->
              <v-stepper-step :complete="categoryStep > 2" step="2">
                Link with Use Case
                <small>(Optional)</small>
              </v-stepper-step>
              <v-stepper-content step="2">
                <v-form>
                  <v-checkbox
                    v-model="linkWithSubLicense"
                    label="Do you want to link this form to any Use Case?"
                    class="ml-2"
                  ></v-checkbox>
                  <v-select
                    v-if="linkWithSubLicense"
                    v-model="selectedUseCase"
                    label="Select Use Case"
                    :items="useCases"
                    outlined
                    dense
                    hide-details
                    clearable
                    class="mb-4"
                    @change="fetchExtendUseCaseData"
                  ></v-select>

                  <v-select
                    v-if="selectedUseCase"
                    v-model="selectedSubcase"
                    label="Select Sub-case"
                    :items="allSubCases"
                    :rules="[
                      (v) => (!!v && linkWithSubLicense) || 'Please select a License/Team',
                      (v) => !!v || 'License/Team is required'
                    ]"
                    item-text="name"
                    item-value="_id"
                    outlined
                    dense
                    hide-details
                    clearable
                    class="mb-4"
                    @change="resetQuestionCollectionKeyFields"
                  ></v-select>

                  <div class="flex justify-end mt-4">
                    <v-btn text outlined small @click="categoryStep = 1" class="mr-4 normal-case"
                      >Previous</v-btn
                    >
                    <v-btn
                      color="primary"
                      @click="handleLicenseStepComplete"
                      class="normal-case"
                      small
                      >Next</v-btn
                    >
                  </div>
                </v-form>
              </v-stepper-content>

              <!-- Step 3: Data Category Configuration -->
              <v-stepper-step :complete="categoryStep > 3" step="3">
                Link Data Category
                <small>(Optional)</small>
              </v-stepper-step>
              <v-stepper-content step="3">
                <v-form>
                  <v-checkbox
                    v-model="collectDataBasedOnCategory"
                    label="Do you want to segregate data into a particular category in the linked sub-case?"
                    class="ml-2"
                  ></v-checkbox>

                  <v-select
                    v-if="collectDataBasedOnCategory"
                    label="Select Data Category"
                    v-model="selectedDataCategory"
                    :items="dataCategories"
                    placeholder="Select Data Category"
                    outlined
                    dense
                    clearable
                    hide-details
                    class="mb-4"
                  ></v-select>

                  <div class="flex justify-end mt-4">
                    <v-btn text outlined small @click="categoryStep = 2" class="mr-4 normal-case"
                      >Previous</v-btn
                    >
                    <v-btn
                      color="primary"
                      @click="handleDataCategoryStepComplete"
                      class="normal-case"
                      small
                      >Next</v-btn
                    >
                  </div>
                </v-form>
              </v-stepper-content>
              <!-- Step 4: Auto crate dynamic form -->
              <v-stepper-step :complete="categoryStep > 4" step="4">
                Auto Generate Form Fields
                <small>(Optional)</small>
              </v-stepper-step>
              <v-stepper-content step="4">
                <v-form>
                  <v-checkbox
                    v-model="autoCreateDynamicForm"
                    label="Do you want to generate form fields based on the linked sub-case?"
                    class="ml-2"
                  ></v-checkbox>
                  <div class="flex justify-end mt-4">
                    <v-btn text outlined @click="categoryStep = 3" small class="mr-4 normal-case"
                      >Previous</v-btn
                    >
                    <v-btn color="primary" @click="handleAutoFormComplete" class="normal-case" small
                      >Next</v-btn
                    >
                  </div>
                </v-form>
              </v-stepper-content>

              <!-- Step 5: Notification Configuration -->
              <v-stepper-step :complete="categoryStep > 5" step="5">
                Add Notifications
                <small>(Optional)</small>
              </v-stepper-step>
              <v-stepper-content step="5">
                <v-form>
                  <v-checkbox
                    v-model="triggerNotifications"
                    label="Do you want to trigger a notification on form submission?"
                    class="ml-2"
                  ></v-checkbox>
                  <template v-if="triggerNotifications">
                    <v-select
                      label="Select Template(s)"
                      :items="whatsappTriggers"
                      v-model="selectedTemplatesList"
                      item-text="templateName"
                      return-object
                      outlined
                      multiple
                      dense
                      clearable
                      hide-details
                      class="mb-4"
                    ></v-select>
                  </template>

                  <template>
                    <div
                      v-if="triggerNotifications && selectedTemplatesList.length > 0"
                      class="mb-4 bg-white border border-gray-200 rounded-lg p-4"
                    >
                      <v-row class="mb-1 px-3 pt-3">
                        <v-col
                          cols="6"
                          class="font-weight-bold text-gray-800"
                          style="font-size: 14px"
                        >
                          Template Name
                        </v-col>
                        <v-col
                          cols="6"
                          class="font-weight-bold text-gray-800 text-right"
                          style="font-size: 14px"
                        >
                          Notification Type
                        </v-col>
                      </v-row>
                      <v-divider></v-divider>

                      <!-- Data Rows -->
                      <v-row
                        v-for="item in selectedTemplatesListDetails"
                        :key="item._id"
                        class="mt-2 px-3 pb-2"
                      >
                        <v-col cols="6" class="text-gray-900" style="font-size: 13px">
                          {{ titleCase(item.templateName) }}
                        </v-col>
                        <v-col cols="6" class="text-gray-900 text-right" style="font-size: 13px">
                          {{ item.notificationType.join(', ') }}
                        </v-col>
                      </v-row>
                    </div>
                  </template>
                </v-form>
                <div class="flex justify-end mt-4 pt-4">
                  <v-btn
                    text
                    outlined
                    class="normal-case"
                    @click="linkWithSubLicense ? (categoryStep = 4) : (categoryStep = 2)"
                    small
                    >Previous</v-btn
                  >
                </div>
              </v-stepper-content>
            </div>
          </v-stepper>
        </div>
        <div class="flex justify-end border-t border-gray-200 bg-white p-4">
          <v-btn text @click="showAddCategoryModal = false" class="mr-4 normal-case">Cancel</v-btn>
          <v-btn color="primary" @click="confirmAddCategory" small class="normal-case">
            <v-icon left>mdi-content-save</v-icon> Save
          </v-btn>
        </div>
      </div>
    </v-dialog>

    <!-- Copy Questions Modal -->
    <v-dialog v-model="showCopyQuestionsModal" max-width="800px">
      <v-card class="rounded-lg">
        <div class="bg-blue-50 p-4">
          <div class="flex items-center justify-between w-full">
            <div class="flex items-center">
              <v-icon color="blue" class="mr-3">mdi-content-copy</v-icon>
              <div>
                <h3 class="text-lg font-semibold text-gray-800">Copy Questions from Form</h3>
                <p class="text-sm text-gray-600" v-if="selectedCategory">
                  Copy to: {{ selectedCategory.categoryName }}
                </p>
              </div>
            </div>
            <v-btn icon @click="showCopyQuestionsModal = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </div>

        <div class="p-6">
          <!-- Source Form Selection -->
          <div class="mb-6">
            <v-select
              v-model="selectedSourceCategory"
              :items="availableSourceCategories"
              item-text="categoryName"
              item-value="_id"
              label="Select Form to Copy From"
              outlined
              dense
              class="mb-4"
              @change="loadSourceQuestions"
              :disabled="availableSourceCategories.length === 0"
            >
              <template v-slot:item="{ item }">
                <div class="py-2">
                  <div class="font-medium text-base">{{ item.categoryName }}</div>
                  <div class="text-sm text-gray-600">
                    {{ item.questions ? item.questions.length : 0 }} question{{
                      item.questions && item.questions.length !== 1 ? 's' : ''
                    }}
                  </div>
                </div>
              </template>
            </v-select>

            <div v-if="availableSourceCategories.length === 0" class="text-center py-4">
              <v-icon size="48" color="grey lighten-2">mdi-alert-circle</v-icon>
              <p class="text-gray-500 mt-2">No other forms available to copy from</p>
              <p class="text-sm text-gray-400">Create more forms to use the copy feature</p>
            </div>
          </div>

          <!-- Questions List -->
          <div v-if="sourceQuestions.length > 0" class="mb-6">
            <div class="flex items-center justify-between mb-4">
              <h4 class="font-medium text-gray-800">Select Questions to Copy</h4>
              <div class="flex justify-end space-x-2">
                <v-btn small text color="primary" @click="selectAllQuestions" class="normal-case">
                  Select All
                </v-btn>
                <v-btn small text color="grey" @click="deselectAllQuestions" class="normal-case">
                  Deselect All
                </v-btn>
              </div>
            </div>

            <div class="max-h-96 overflow-y-auto border border-gray-200 rounded-lg">
              <div
                v-for="(question, index) in sourceQuestions"
                :key="index"
                class="border-b border-gray-100 last:border-b-0"
              >
                <div class="p-4 hover:bg-gray-50">
                  <v-checkbox
                    v-model="selectedQuestions"
                    :value="question"
                    hide-details
                    class="ma-0"
                  >
                    <template v-slot:label>
                      <div class="flex items-center space-x-3 ml-2">
                        <v-icon :color="getTypeColor(question.questionType)" small>
                          {{ getTypeIcon(question.questionType) }}
                        </v-icon>
                        <div class="flex-grow">
                          <div class="font-medium text-sm">
                            {{ question.question }}
                            <span v-if="question.isRequired" class="text-red-500">*</span>
                          </div>
                          <div class="text-xs text-gray-500 mt-1">
                            Type: {{ formatType(question.questionType) }}
                            <span v-if="question.options && question.options.length > 0">
                              • {{ question.options.length }} option{{
                                question.options.length !== 1 ? 's' : ''
                              }}
                            </span>
                            <span v-if="question.collectionKeyField">
                              • Mapped to: {{ question.collectionKeyField }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </template>
                  </v-checkbox>
                </div>
              </div>
            </div>

            <div class="mt-4 p-3 bg-blue-50 rounded-lg">
              <div class="flex items-center text-sm text-blue-800">
                <v-icon small color="blue" class="mr-2">mdi-information</v-icon>
                <span>
                  {{ selectedQuestions.length }} of {{ sourceQuestions.length }} questions selected
                </span>
              </div>
            </div>
          </div>

          <div v-else-if="selectedSourceCategory" class="text-center py-8">
            <v-icon size="48" color="grey lighten-2">mdi-help-circle</v-icon>
            <p class="text-gray-500 mt-2">No questions found in the selected form</p>
          </div>

          <div v-else class="text-center py-8">
            <v-icon size="48" color="grey lighten-2">mdi-form-select</v-icon>
            <p class="text-gray-500 mt-2">Please select a form to copy questions from</p>
          </div>

          <!-- Copy Options -->
          <div v-if="sourceQuestions.length > 0" class="mt-6 border-t border-gray-200 pt-6">
            <h4 class="font-medium text-gray-800 mb-4">Copy Options</h4>

            <v-checkbox
              v-model="copyOptions.preserveFieldMappings"
              label="Preserve field mappings (if compatible with target form's use case)"
              hide-details
              class="mb-2"
            ></v-checkbox>

            <v-checkbox
              v-model="copyOptions.preserveValidation"
              label="Preserve validation settings and messages"
              hide-details
              class="mb-2"
            ></v-checkbox>

            <v-checkbox
              v-model="copyOptions.preserveRequiredFlag"
              label="Preserve required field settings"
              hide-details
            ></v-checkbox>
          </div>
        </div>

        <v-card-actions class="px-6 pb-6">
          <v-spacer></v-spacer>
          <v-btn text @click="showCopyQuestionsModal = false" class="normal-case"> Cancel </v-btn>
          <v-btn
            color="primary"
            class="normal-case"
            @click="copySelectedQuestions"
            :disabled="selectedQuestions.length === 0"
            :loading="isCopyingQuestions"
          >
            <v-icon left small>mdi-content-copy</v-icon>
            Copy {{ selectedQuestions.length }} Question{{
              selectedQuestions.length !== 1 ? 's' : ''
            }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showPredefinedSectionDialog" max-width="90rem" class="bg-white" persistent>
      <PredefinedFormBuilder
        @questions-saved="handlePredefinedQuestionsSaved"
        @close="closePredefinedSectionDialog"
        :selectedPredefinedSection="selectedPredefinedSection"
        :existing-questions="existingQuestionsForPredefinedForm"
      />
    </v-dialog>
  </div>
</template>

<script>
import { APP_URL } from '@/utils/workforce/constants'
import DraggableWrapper from '@/components/common/DraggableWrapper.vue'
import { convertToTitleCase } from '@/utils/common'
import NoData from '@/components/NoData.vue'
import PredefinedFormBuilder from '../../EmployeeManagement/PredefinedFormBuilder.vue'
import QuestionPreview from './QuestionPreview.vue'
import PopOverMenu from '@/components/UI/PopOverMenu.vue'
import { axiosUrl } from '@/utils/workforceApi'

// import StickyWrapper from '@/components/common/StickyWrapper.vue'
export default {
  name: 'CategoryQuestionnaire',
  components: {
    DraggableWrapper,
    QuestionPreview,
    NoData,
    PredefinedFormBuilder,
    PopOverMenu
    // StickyWrapper
  },
  props: {
    receivedData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      orgData: this.$storage.getUniversal('orgData'),
      subCases: this.$store.state.subCases,
      allSubCases: [],
      currentQuestionType: null,
      questionnaire: [],
      dataCategories: [],
      departments: [],
      editingQuestionIndex: null,
      editingQuestionId: null,
      editingCategoryName: null,
      expandedCategory: null,
      isLoading: false,
      isPrivate: false,
      showCategoryMenu: false,
      selectedDataCategory: null,

      // Form fields
      questionCategory: null,
      questionText: '',
      isRequired: false,
      validationMessage: 'This field is mandatory',
      maxAttachments: 1,
      maxFileSize: 10,
      mediaMaxSize: 20,
      mediaQuality: 'Medium',

      // Category fields
      isSpecialCategory: false,
      specialCategories: [],
      editCategoryId: null,
      categoryHeader: '',
      categoryImages: {
        logo: null,
        banner: null
      },

      // UI state
      showAddCategoryModal: false,
      newCategoryName: '',
      options: [],
      newOption: '',
      selectedPredefinedSection: null,
      showPredefinedSectionDialog: false,
      existingQuestionsForPredefinedForm: [],

      selectedPaymentType: 'QR_CODE',
      paymentTypes: [
        { text: 'QR Code', value: 'QR_CODE' },
        { text: 'Google Pay', value: 'GOOGLE_PAY' },
        { text: 'Payment Link', value: 'PAYMENT_LINK' },
        { text: 'Razorpay', value: 'RAZORPAY' },
        { text: 'PayPal', value: 'PAYPAL' }
      ],
      selectedUseCase: null,

      // Question types configuration
      questionTypes: [
        {
          value: 'TEXT',
          label: 'Text',
          icon: 'mdi-form-textbox',
          color: 'blue',
          enabled: true,
          visible: true
        },
        {
          value: 'TEXTAREA',
          label: 'Text Area',
          icon: 'mdi-text-box-outline',
          color: 'green',
          enabled: true,
          visible: true
        },
        {
          value: 'NUMBER',
          label: 'Number',
          icon: 'mdi-numeric',
          color: 'orange',
          enabled: true,
          visible: true
        },
        {
          value: 'CHECKBOX',
          label: 'Checkbox',
          icon: 'mdi-checkbox-marked-outline',
          color: 'teal',
          enabled: true,
          visible: true
        },
        {
          value: 'RADIO',
          label: 'Radio',
          icon: 'mdi-radiobox-marked',
          color: 'amber',
          enabled: true,
          visible: true
        },
        {
          value: 'SELECT_OPTIONS',
          label: 'Select Options',
          icon: 'mdi-form-dropdown',
          color: 'purple',
          enabled: true,
          visible: true
        },
        {
          value: 'MULTI_TEXT',
          label: 'Multi Text',
          icon: 'mdi-text-box-multiple-outline',
          color: 'cyan',
          enabled: true,
          visible: true
        },
        // {
        //   value: 'SERVICE_PLAN',
        //   label: 'Payment Plan',
        //   icon: 'mdi-credit-card',
        //   color: 'blue',
        //   enabled: true,
        //   visible: true
        // },
        {
          value: 'LOCAL_ATTACHMENTS',
          label: 'Attachment',
          icon: 'mdi-paperclip',
          color: 'purple',
          enabled: true,
          visible: true
        },
        {
          value: 'AUDIO_CAPTURE',
          label: 'Audio',
          icon: 'mdi-microphone',
          color: 'red',
          enabled: true,
          visible: true
        },
        {
          value: 'VIDEO_CAPTURE',
          label: 'Video',
          icon: 'mdi-video',
          color: 'indigo',
          enabled: true,
          visible: true
        },
        {
          value: 'CLICK_PICTURES',
          label: 'Live Picture',
          icon: 'mdi-camera',
          color: 'pink',
          enabled: true,
          visible: true
        },
        {
          value: 'DATA_CATEGORY',
          label: 'Data Category',
          icon: 'mdi-folder-multiple-outline',
          color: 'teal',
          enabled: true,
          visible: true
        },
        {
          value: 'DATE',
          label: 'Date',
          icon: 'mdi-calendar',
          color: 'blue',
          enabled: true,
          visible: true
        }
      ],
      optionsItems: [],
      paymentQRImage: null,
      selectedSubcase: null,
      linkedKey: null,
      paymentLink: '',
      payment_UPI_Id: '',
      paymentPlans: [],
      subcaseChangeinfo: false,
      whatsappTriggers: [],
      notificationTypes: ['WHATSAPP', 'SMS', 'EMAIL'],
      selectedNotificationTypes: [],
      selectedTemplates: {
        WHATSAPP: [],
        SMS: [],
        EMAIL: []
      },
      smsTemplates: [
        { _id: 'sms1', templateName: 'Order Confirmation' },
        { _id: 'sms2', templateName: 'Delivery Update' },
        { _id: 'sms3', templateName: 'Payment Reminder' },
        { _id: 'sms4', templateName: 'Appointment Confirmation' }
      ],
      emailTemplates: [
        { _id: 'email1', templateName: 'Welcome Email' },
        { _id: 'email2', templateName: 'Order Receipt' },
        { _id: 'email3', templateName: 'Monthly Newsletter' },
        { _id: 'email4', templateName: 'Password Reset' }
      ],
      useCases: [],
      // Stepper related fields
      categoryStep: 1,
      linkWithSubLicense: false,
      linkWithDesignation: false,
      selectedDepartment: null,
      selectedDesignation: null,
      designations: [],
      collectDataBasedOnCategory: false,
      triggerNotifications: false,
      autoCreateDynamicForm: false,
      selectedFormId: null,

      // New state for selected templates
      allTemplates: [],
      selectedTemplatesList: [],
      selectedTemplatesListDetails: [],

      // Form connections state
      showConnectionsModal: false,
      showAddConnectionModal: false,
      selectedFormForConnections: null,
      formConnections: [],
      selectedModuleToConnect: null,
      connectionNotes: '',
      availableModules: [
        {
          id: 'workflow_steps',
          name: 'Workflow Steps',
          description: 'Integration with workflow management system',
          icon: 'mdi-workflow',
          iconColor: 'blue'
        },
        {
          id: 'case_management',
          name: 'Case Management',
          description: 'Link form to case creation and updates',
          icon: 'mdi-briefcase',
          iconColor: 'green'
        },
        {
          id: 'visit_tracking',
          name: 'Visit Tracking',
          description: 'Capture visit information and reports',
          icon: 'mdi-map-marker',
          iconColor: 'orange'
        },
        {
          id: 'employee_onboarding',
          name: 'Employee Onboarding',
          description: 'New employee registration and documentation',
          icon: 'mdi-account-plus',
          iconColor: 'purple'
        },
        {
          id: 'customer_feedback',
          name: 'Customer Feedback',
          description: 'Collect and manage customer feedback',
          icon: 'mdi-comment-account',
          iconColor: 'teal'
        },
        {
          id: 'audit_checklist',
          name: 'Audit Checklist',
          description: 'Quality assurance and audit processes',
          icon: 'mdi-clipboard-check',
          iconColor: 'red'
        }
      ],

      // Copy questions modal data
      showCopyQuestionsModal: false,
      selectedSourceCategory: null,
      sourceQuestions: [],
      selectedQuestions: [],
      isCopyingQuestions: false,
      copyOptions: {
        preserveFieldMappings: true,
        preserveValidation: true,
        preserveRequiredFlag: true
      },
      subCaseMapping: {},

      // Server-side pagination data
      currentPage: 1,
      itemsPerPage: 10,
      totalCount: 0,
      totalPages: 0,
      isLoadingMore: false,
      sendingLinks: {}
    }
  },
  watch: {
    expandedCategory: {
      async handler(newVal) {
        this.selectedFormId = this.categories[newVal]?.formId
        if (newVal !== null && this.questionnaire[newVal]) {
          this.questionCategory = this.getCategoryKey(this.questionnaire[newVal].categoryName)
          this.selectedSubcase = this.questionnaire[newVal].subCase?._id
          this.selectedUseCase = this.questionnaire[newVal]?.useCase
          this.isSpecialCategory = this.questionnaire[newVal]?.specialCategory || false
          this.selectedSpecialCategory = this.questionnaire[newVal]?.specialCategory
          this.selectedDataCategory = this.questionnaire[newVal].dataCategory
          this.selectedDepartment = this.questionnaire[newVal].department
          this.fetchDataCategories()
          this.fetchExtendUseCaseMapping(this.selectedSubcase)
          this.fetchExtendUseCaseData()
          await this.fetchDesignationsByDepartment(this.selectedDepartment)
          this.selectedDesignation = this.questionnaire[newVal].designation
        }
      }
    },
    currentQuestionType(newType) {
      if (newType === 'DATA_CATEGORY') {
        this.fetchDataCategories()
      }
    },
    selectedSubcase(newSubcase) {
      if (newSubcase) {
        this.fetchDataCategories()
      }
      const dataCategoryType = this.questionTypes.find((type) => type.value === 'DATA_CATEGORY')
      if (newSubcase) {
        dataCategoryType.visible = true
      } else {
        dataCategoryType.visible = false
      }
    },
    selectedDataCategory: {
      handler(newVal) {
        this.toggleDataCategory()
      },
      immediate: true
    },
    // triggerNotifications: {
    //   handler(newVal) {
    //     if (!newVal) {
    //       this.selectedTemplatesList = []
    //     }
    //   },
    //   immediate: true
    // },
    selectedTemplatesList: {
      handler(newList) {
        this.selectedTemplatesListDetails = newList.map((el) => {
          return {
            _id: el?._id,
            templateName: el?.templateName,
            notificationType: el?.typesOfNotification
          }
        })
      },
      immediate: true
    }
  },
  async created() {
    await this.fetchCategories(1, false) // Load first page

    if (this.questionnaire.length > 0) {
      this.expandedCategory = 0
      this.questionCategory = this.getCategoryKey(this.questionnaire[0].categoryName)
      this.selectedSubcase = this.questionnaire[0].subCase
      this.selectedDataCategory = this.questionnaire[0].dataCategory || null
      this.selectedDepartment = this.questionnaire[0].department || null
      this.selectedDesignation = this.questionnaire[0].designation || null
    } else {
      this.expandedCategory = null
      this.questionCategory = null
      this.selectedDataCategory = null
      this.selectedDepartment = null
      this.selectedDesignation = null
    }

    // Fetch all templates for notifications
    await this.fetchAllTemplates()
  },
  computed: {
    categories() {
      return this.questionnaire
    },
    selectedCategory() {
      return this.expandedCategory !== null ? this.questionnaire[this.expandedCategory] : null
    },
    getBannerImage() {
      if (this.selectedCategory?.images) {
        const banner = this.selectedCategory.images.find((img) => img.type === 'banner')
        return banner ? this.bannerLogoUrl(banner.path) : null
      }
      return null
    },
    getLogoImage() {
      if (this.selectedCategory?.images) {
        const logo = this.selectedCategory.images.find((img) => img.type === 'logo')
        return logo ? this.bannerLogoUrl(logo.path) : null
      }
      return null
    },
    isAddButtonEnable() {
      return !this.currentQuestionType || !this.questionText || !this.questionCategory
    },
    fieldMappings() {
      const dynamicRequestPath = {
        collection_management: {
          path: 'collection-management-field-mapping',
          key: 'collectionManagementFieldMapping'
        },
        loan_management: {
          path: 'loan-management-field-mapping',
          key: 'loanManagementFieldMapping'
        }
      }

      if (!this.subCaseMapping || !this.subCaseMapping?.baseFieldMappings) return []
      // console.log(this.selectedUseCase)
      const fieldMappings = {
        ...this.subCaseMapping.baseFieldMappings,
        ...this.subCaseMapping[dynamicRequestPath[this.selectedUseCase]?.key],
        ...this.subCaseMapping.customerFieldMappings
      }

      const items = Object.entries(fieldMappings).map(([key, value]) => ({
        text: value?.displayName ? `${value?.displayName} - (${key})` : null,
        value: key
      }))
      const filtredItems = items.filter((item) => item.text)
      return filtredItems
    },
    isWhatsappTriggerAvailable() {
      return !!this.receivedData?.applications?.whatsapp?.waSystemToken
    },
    templateNameWithType() {
      return (item) => `${item.templateName} (${item.notificationType})`
    },
    availableSourceCategories() {
      // Return all categories except the currently selected one
      if (this.selectedCategory) {
        return this.questionnaire.filter((cat) => cat._id !== this.selectedCategory._id)
      }
      return this.questionnaire
    },
    canLoadMore() {
      return this.currentPage < this.totalPages
    },
    showLoadMoreButton() {
      return this.canLoadMore && this.questionnaire.length > 0
    }
  },
  methods: {
    bannerLogoUrl(path) {
      return path ? `${process.env.VUE_APP_S3_BASE_URL}${path}` : null
    },
    getCategoryKey(categoryName) {
      return categoryName.trim().toLowerCase().replace(/\s+/g, '-')
    },

    getCategoryByKey(categoryKey) {
      return this.questionnaire.find((cat) => this.getCategoryKey(cat.categoryName) === categoryKey)
    },
    closePredefinedSectionDialog() {
      this.showPredefinedSectionDialog = false
      this.existingQuestionsForPredefinedForm = []
      this.selectedPredefinedSection = null
    },
    extractFormType(item) {
      let text = 'Open Ended'
      let color = 'gray'

      switch (true) {
        case !!item.specialCategory:
          text = item.specialCategory
          color = 'blue'
          break
        case !!(item.subCase && item.subCase?._id):
          text = item.subCase.name || ''
          color = 'green'
          break
        default:
          text = 'Open Ended'
          color = 'gray'
      }

      return {
        text,
        color
      }
    },
    async fetchDepartments() {
      try {
        const response = await this.$axios.get(axiosUrl.departments.getDepartments)
        this.departments = response.data.departments || []
      } catch (error) {
        console.error('Error fetching departments:', error)
        this.departments = []
      }
    },
    async fetchDesignationsByDepartment(department) {
      try {
        this.selectedDesignation = null
        const url = department
          ? `${axiosUrl.designations.getDesignations}?department=${department}`
          : axiosUrl.designations.getDesignations
        const response = await this.$axios.get(url)
        this.designations = response.data.designations || []
      } catch (error) {
        console.error('Error fetching designations:', error)
        this.designations = []
      }
    },
    async fetchCategories(page = 1, loadMore = false) {
      try {
        if (!loadMore) {
          this.isLoading = true
        } else {
          this.isLoadingMore = true
        }

        const params = {
          page: page,
          limit: this.itemsPerPage
        }

        const response = await this.$axios.get('/orgSetup/dynamic-forms', { params })
        if (response.data && response.data.data) {
          if (loadMore) {
            // Append new categories to existing ones
            this.questionnaire = [...this.questionnaire, ...response.data.data]
          } else {
            // Replace categories for initial load
            this.questionnaire = response.data.data
          }

          // Update pagination info from server response
          if (response.data.pagination) {
            this.totalCount = response.data.pagination.totalCount || response.data.totalCount
            this.totalPages = response.data.pagination.totalPages || response.data.totalPages
            this.currentPage = response.data.pagination.currentPage || response.data.currentPage
          } else if (response.data.totalCount !== undefined) {
            // Fallback for different response structure
            this.totalCount = response.data.totalCount
            this.totalPages = response.data.totalPages
            this.currentPage = response.data.currentPage
          }
        }
      } catch (error) {
        console.error('Error fetching categories:', error)
        this.$toast.error('Failed to load questionnaire categories')
      } finally {
        this.isLoading = false
        this.isLoadingMore = false
      }
    },
    titleCase(str) {
      return convertToTitleCase(str)
    },

    selectQuestionType(type) {
      this.currentQuestionType = type
    },

    async saveQuestion() {
      if (this.isAddButtonEnable) {
        this.$toast.error('Please select a category, question type, and enter question text')
        return
      }

      try {
        this.isLoading = true

        const question = {
          question: this.questionText,
          questionType: this.currentQuestionType,
          isRequired: this.isRequired,
          options: [],
          validationMessage: this.validationMessage || '',
          collectionKeyField: this.linkedKey || undefined,
          userResponse: null
        }

        if (
          this.currentQuestionType === 'CHECKBOX' ||
          this.currentQuestionType === 'RADIO' ||
          this.currentQuestionType === 'SELECT_OPTIONS'
        ) {
          if (!this.options || this.options.length === 0) {
            this.$toast.error('Please add at least one option for Checkbox/Radio question')
            return
          }
          question.options = [...this.options]
        } else if (this.currentQuestionType === 'DATA_CATEGORY') {
          const categoryOptions = this.dataCategories.map((cat) => {
            return { label: cat.text, value: cat.value }
          })
          question.options = JSON.stringify(categoryOptions)
          question.dataCategory = true
        }

        if (this.currentQuestionType === 'LOCAL_ATTACHMENTS') {
          question.allowedNoOfAttachments = this.maxAttachments
        }
        // if (this.currentQuestionType === 'SERVICE_PLAN') {
        //   if (!this.paymentPlans || this.paymentPlans.length === 0) {
        //     this.$toast.error('Please add at least one payment plan')
        //     return
        //   }
        //   question.payment_Plan = [...this.paymentPlans]
        //   question.paymentLink = this.paymentLink || null
        //   question.payment_UPI_Id = this.payment_UPI_Id || null
        //   question.paymentIntegrationType = this.selectedPaymentType
        //   if (this.paymentQRImage) {
        //     question.options = [this.paymentQRImage.path]
        //   }
        // }

        const category = this.getCategoryByKey(this.questionCategory)
        if (!category) {
          this.$toast.error('Category not found')
          return
        }

        // Prepare category data with updated questions
        const updatedQuestions = [...(category.questions || [])]

        if (this.editingQuestionIndex !== null) {
          // Update existing question
          if (this.editingQuestionId) {
            question._id = this.editingQuestionId
          }
          updatedQuestions[this.editingQuestionIndex] = question
        } else {
          // Add new question
          updatedQuestions.push(question)
        }

        // Prepare category data for API call
        const categoryData = {
          isPrivate: category.isPrivate,
          categoryName: category.categoryName,
          header: category.header || '',
          images: category.images || [],
          questions: updatedQuestions,
          subCase: category.subCase ? category.subCase : undefined,
          dataCategory: category.dataCategory || null,
          enabledNotifications: category.enabledNotifications || null
        }

        // Make API call to update category with new/updated question
        const response = await this.$axios.put(
          `/orgSetup/dynamic-form/${category._id}`,
          categoryData
        )

        // Update local data
        const updatedCategory = response.data.data || categoryData
        const categoryIndex = this.questionnaire.findIndex((cat) => cat._id === category._id)
        if (categoryIndex !== -1) {
          this.$set(this.questionnaire, categoryIndex, updatedCategory)
        }

        this.$toast.success(
          this.editingQuestionIndex !== null
            ? 'Question updated successfully!'
            : 'Question added successfully!'
        )

        this.resetQuestionForm()
      } catch (error) {
        console.error('Error saving question:', error)
        this.$toast.error('Failed to save question')
      } finally {
        this.isLoading = false
      }
    },

    resetQuestionForm() {
      this.questionText = ''
      this.isRequired = false
      this.validationMessage = ''
      this.currentQuestionType = null
      this.editingQuestionIndex = null
      this.editingQuestionId = null
      this.maxAttachments = 1
      this.maxFileSize = 10
      this.mediaMaxSize = 20
      this.mediaQuality = 'Medium'
      this.options = []
      this.paymentQRImage = null
      this.paymentLink = ''
      this.payment_UPI_Id = ''
      this.paymentPlans = []
      this.linkedKey = null
    },
    resetCategoryForm() {
      this.newCategoryName = ''
      this.categoryHeader = ''
      this.selectedSubcase = null
      this.selectedUseCase = null
      this.isSpecialCategory = false
      this.selectedSpecialCategory = null
      this.selectedDataCategory = null
      this.selectedDepartment = null
      this.selectedDesignation = null
      this.categoryImages = { logo: null, banner: null }
    },
    async confirmAddCategory() {
      const name = this.newCategoryName.trim()
      if (!name) {
        this.$toast.error('Please enter a category name')
        return
      }

      try {
        this.isLoading = true

        let enabledNotifications = []
        if (this.triggerNotifications && this.selectedTemplatesList.length > 0) {
          this.selectedTemplatesList.forEach((template) => {
            if (template.typesOfNotification && Array.isArray(template.typesOfNotification)) {
              template.typesOfNotification.forEach((notificationType) => {
                enabledNotifications.push({
                  typeOfNotification: notificationType,
                  templateId: [template._id],
                  templateName: template.templateName
                })
              })
            } else {
              enabledNotifications.push({
                typeOfNotification: 'WHATSAPP',
                templateId: [template._id],
                templateName: template.templateName
              })
            }
          })
        }

        const images = []
        if (this.categoryImages.logo) {
          images.push({ type: 'logo', path: this.categoryImages.logo.path })
        }
        if (this.categoryImages.banner) {
          images.push({ type: 'banner', path: this.categoryImages.banner.path })
        }

        const categoryData = {
          isPrivate: this.isPrivate,
          categoryName: name,
          header: this.categoryHeader || '',
          images: images,
          questions: [],
          specialCategory: this.isSpecialCategory ? this.selectedSpecialCategory : undefined,
          subCase: this.selectedSubcase ? this.selectedSubcase : undefined,
          useCase: this.selectedUseCase || '',
          dataCategory: this.selectedDataCategory || null,
          department: this.selectedDepartment || null,
          designation: this.selectedDesignation || null,
          enabledNotifications: enabledNotifications.length > 0 ? enabledNotifications : null
        }

        let categoryIndex = -1
        let savedCategory = null

        if (this.editingCategoryName) {
          categoryIndex = this.questionnaire.findIndex(
            (cat) => cat.categoryName === this.editingCategoryName
          )

          if (categoryIndex !== -1) {
            const existingCategory = this.questionnaire[categoryIndex]
            const oldSubcase = existingCategory.subCase

            categoryData.questions = existingCategory.questions || []

            if (oldSubcase !== this.selectedSubcase && categoryData.questions.length > 0) {
              categoryData.questions.forEach((question) => {
                question.collectionKeyField = null
              })
              this.$toast.info('Question field mappings have been reset due to license/team change')
            }

            const response = await this.$axios.put(
              `/orgSetup/dynamic-form/${existingCategory._id}`,
              categoryData
            )
            savedCategory = response.data.data || { ...categoryData, _id: existingCategory._id }

            this.$set(this.questionnaire, categoryIndex, savedCategory)
            this.$toast.success('Form updated successfully!')
          }
        } else {
          const response = await this.$axios.post('/orgSetup/dynamic-form', categoryData)
          savedCategory = response.data.data || categoryData

          // For new category, refresh the list to get updated pagination
          await this.fetchCategories(1, false)

          // Find the new category in the updated list
          const newCategoryIndex = this.questionnaire.findIndex(
            (cat) =>
              cat._id === savedCategory._id || cat.categoryName === savedCategory.categoryName
          )

          if (newCategoryIndex !== -1) {
            categoryIndex = newCategoryIndex
          } else {
            categoryIndex = this.questionnaire.length - 1
          }

          this.$toast.success('Form created successfully!')
        }

        if (this.autoCreateDynamicForm && savedCategory) {
          await this.autoGenerateQuestions(savedCategory)
        }

        this.showAddCategoryModal = false
        this.editingCategoryName = null
        this.subcaseChangeinfo = false

        this.$nextTick(() => {
          this.expandedCategory = categoryIndex
          this.questionCategory = this.getCategoryKey(savedCategory.categoryName)
        })
      } catch (error) {
        console.error('Error saving category:', error)
        this.$toast.error('Failed to save form')
      } finally {
        this.isLoading = false
      }
    },
    toggleDataCategory() {
      const dataCategoryType = this.questionTypes.find((type) => type.value === 'DATA_CATEGORY')
      if (dataCategoryType) {
        const currentCategory = this.selectedCategory
        if (currentCategory) {
          dataCategoryType.enabled = !currentCategory.dataCategory
        }
      }
    },
    editCategory(categoryName) {
      const categoryIndex = this.questionnaire.findIndex((cat) => cat.categoryName === categoryName)
      if (categoryIndex !== -1) {
        const category = this.questionnaire[categoryIndex]
        this.newCategoryName = category.categoryName
        this.editingCategoryName = categoryName
        this.editCategoryId = category._id
        this.categoryHeader = category.header || ''
        this.isPrivate = category.isPrivate || false
        // Set stepper toggle values based on existing data
        this.linkWithSubLicense = !!category.subCase
        this.selectedSubcase = category.subCase || null
        this.selectedUseCase = category.useCase || null
        this.isSpecialCategory = !!category.specialCategory || false
        this.selectedSpecialCategory = category?.specialCategory || null
        this.collectDataBasedOnCategory = !!category.dataCategory
        this.selectedDataCategory = category.dataCategory || null
        this.selectedDepartment = category.department || null
        this.selectedDesignation = category.designation || null
        this.linkWithDesignation = !!category.department

        // Fix notification templates population
        this.triggerNotifications = !!(
          category.enabledNotifications && category.enabledNotifications.length > 0
        )

        // Reset selected templates
        this.selectedTemplatesList = []
        this.selectedTemplatesListDetails = []

        // If category has enabled notifications, populate the templates
        if (category.enabledNotifications && category.enabledNotifications.length > 0) {
          const templateIds = category.enabledNotifications.flatMap((n) => n.templateId || [])
          this.selectedTemplatesList = this.whatsappTriggers.filter((t) =>
            templateIds.includes(t._id)
          )
        }

        // Add preview URLs for existing images
        this.categoryImages = {
          logo: category.images?.find((img) => img.type === 'logo') || null,
          banner: category.images?.find((img) => img.type === 'banner') || null
        }

        if (this.categoryImages.logo) {
          this.categoryImages.logo.preview = this.bannerLogoUrl(this.categoryImages.logo.path)
        }
        if (this.categoryImages.banner) {
          this.categoryImages.banner.preview = this.bannerLogoUrl(this.categoryImages.banner.path)
        }

        // Keep the current category expanded
        this.expandedCategory = categoryIndex

        // Reset stepper to first step
        this.categoryStep = 1
        this.showAddCategoryModal = true
      }
    },

    async deleteCategory(categoryName) {
      if (
        !confirm(
          'Are you sure you want to delete this category? All questions in this category will also be deleted.'
        )
      ) {
        return
      }

      try {
        this.isLoading = true

        const categoryIndex = this.questionnaire.findIndex(
          (cat) => cat.categoryName === categoryName
        )
        if (categoryIndex === -1) return

        const category = this.questionnaire[categoryIndex]

        await this.$axios.delete(`/orgSetup/dynamic-form/${category._id}`)

        // Refresh the categories list to get updated pagination
        await this.fetchCategories(1, false)

        // Reset expanded category since the list has changed
        this.expandedCategory = null
        this.questionCategory = null

        this.$toast.success('Form deleted successfully!')
      } catch (error) {
        console.error('Error deleting category:', error)
        this.$toast.error('Failed to delete form')
      } finally {
        this.isLoading = false
      }
    },

    editQuestion(categoryName, questionIndex) {
      const category = this.questionnaire.find((cat) => cat.categoryName === categoryName)
      if (!category) return

      const question = category.questions[questionIndex]
      if (!question) return

      // Set form values
      this.questionText = question.question
      this.questionCategory = this.getCategoryKey(categoryName)
      this.isRequired = question.isRequired
      this.validationMessage = question.validationMessage || ''
      this.editingQuestionIndex = questionIndex
      this.editingQuestionId = question._id
      this.currentQuestionType = question.questionType
      this.linkedKey = question.collectionKeyField || null

      // Set options for checkbox and radio types
      if (
        question.options &&
        (question.questionType === 'CHECKBOX' ||
          question.questionType === 'RADIO' ||
          question.questionType === 'SELECT_OPTIONS')
      ) {
        this.options = [...question.options]
      } else {
        this.options = []
      }

      // if (
      //   question.questionType === 'SERVICE_PLAN' &&
      //   question.paymentIntegrationType == 'QR_CODE' &&
      //   question.options &&
      //   question.options.length > 0
      // ) {
      //   this.paymentQRImage = {
      //     path: question.options[0],
      //     preview: this.bannerLogoUrl(question.options[0])
      //   }
      // } else {
      //   this.paymentQRImage = null
      // }

      // Set specific options based on type
      if (question.questionType === 'LOCAL_ATTACHMENTS') {
        this.maxAttachments = question.allowedNoOfAttachments || 1
      }

      // if (question.questionType === 'SERVICE_PLAN') {
      //   this.paymentLink = question.paymentLink || ''
      //   this.payment_UPI_Id = question.payment_UPI_Id || ''
      // }

      // if (question.questionType === 'SERVICE_PLAN' && question.payment_Plan) {
      //   this.paymentPlans = [...question.payment_Plan]
      // } else {
      //   this.paymentPlans = []
      // }
    },

    async deleteQuestion(categoryName, questionIndex, sectionIndex) {
      const isSectionQuestion = sectionIndex !== undefined && typeof sectionIndex === 'number'

      if (!confirm('Are you sure you want to delete this question?')) {
        return
      }

      try {
        this.isLoading = true

        const category = this.questionnaire.find((cat) => cat.categoryName === categoryName)
        if (!category) return

        if (!isSectionQuestion) {
          // Regular question deletion
          const updatedQuestions = [...(category.questions || [])]
          updatedQuestions.splice(questionIndex, 1)

          const categoryData = {
            isPrivate: category.isPrivate,
            categoryName: category.categoryName,
            header: category.header || '',
            images: category.images || [],
            questions: updatedQuestions,
            subCase: category.subCase ? category.subCase : undefined,
            dataCategory: category.dataCategory || null,
            enabledNotifications: category.enabledNotifications || null
          }

          const response = await this.$axios.put(
            `/orgSetup/dynamic-form/${category._id}`,
            categoryData
          )

          const updatedCategory = response.data.data || categoryData
          const categoryIndex = this.questionnaire.findIndex((cat) => cat._id === category._id)
          if (categoryIndex !== -1) {
            this.$set(this.questionnaire, categoryIndex, updatedCategory)
          }

          this.$toast.success('Question deleted successfully!')
        } else {
          // Section question deletion
          if (!category.sections || !category.sections[sectionIndex]) return

          // Create a copy of the section with the question removed
          const updatedSections = [...category.sections]
          const updatedQuestions = [...updatedSections[sectionIndex].questions]
          updatedQuestions.splice(questionIndex, 1)
          updatedSections[sectionIndex] = {
            ...updatedSections[sectionIndex],
            questions: updatedQuestions
          }

          // Prepare category data with updated section questions
          const categoryData = {
            isPrivate: category.isPrivate,
            categoryName: category.categoryName,
            header: category.header || '',
            images: category.images || [],
            questions: category.questions || [],
            sections: updatedSections,
            subCase: category.subCase ? category.subCase : undefined,
            dataCategory: category.dataCategory || null,
            enabledNotifications: category.enabledNotifications || null
          }

          const response = await this.$axios.put(
            `/orgSetup/dynamic-form/${category._id}`,
            categoryData
          )

          const updatedCategory = response.data.data || categoryData
          const categoryIndex = this.questionnaire.findIndex((cat) => cat._id === category._id)
          if (categoryIndex !== -1) {
            this.$set(this.questionnaire, categoryIndex, updatedCategory)
          }

          this.$toast.success('Question deleted successfully!')
        }
      } catch (error) {
        console.error('Error deleting question:', error)
        this.$toast.error('Failed to delete question')
      } finally {
        this.isLoading = false
      }
    },
    getTypeIcon(type) {
      const typeConfig = this.questionTypes.find((t) => t.value === type)
      return typeConfig ? typeConfig.icon : 'mdi-help-circle'
    },

    getTypeColor(type) {
      const typeConfig = this.questionTypes.find((t) => t.value === type)
      return typeConfig ? typeConfig.color : 'grey'
    },

    formatType(type) {
      const typeConfig = this.questionTypes.find((t) => t.value === type)
      return typeConfig
        ? typeConfig.label
        : type.charAt(0).toUpperCase() + type.slice(1).toLowerCase()
    },

    getOptionsText(question) {
      if (question.questionType === 'LOCAL_ATTACHMENTS' && question.allowedNoOfAttachments) {
        return `Max: ${question.allowedNoOfAttachments} file(s)`
      }
      return ''
    },
    copyLinkToClipboard() {
      this.showCategoryMenu = true
    },

    async submitForm(formId, orgId, questionsRes) {
      try {
        const loggingUserId = JSON.parse(localStorage.getItem('user'))?._id
        const submissionData = {
          linkedForm: formId,
          questionsAnswered: questionsRes,
          activities: [
            {
              activityName: 'FORM_SEND',
              updatedBy: loggingUserId || undefined
            }
          ],
          createdBy: loggingUserId || undefined
        }

        let submitUrl = ``
        if (orgId) {
          submitUrl = `/orgSetup/form-response/${orgId}`
        }
        const response = await this.$axios.post(submitUrl, submissionData)
        return {
          responseId: response.data?.response?.responseId || null,
          _id: response.data?.response?._id || null
        }
      } catch (error) {
        console.error('Error submitting form:', error)
        this.$toast.error('Failed to submit form. Please try again.')
      }
    },
    async createMetaData() {
      try {
        const loggingUserId = JSON.parse(localStorage.getItem('user'))?._id
        const metadataData = {}
      } catch (error) {
        console.error('Error creating metadata:', error)
        this.$toast.error('Failed to create metadata. Please try again.')
      }
    },
    async sendLinkToUser(popOverData, category) {
      try {
        this.$set(this.sendingLinks, category._id, true)
        const dummyQuestionRes = JSON.parse(
          JSON.stringify(category.questions, (key, value) => (key === '_id' ? undefined : value))
        )
        const orgData = JSON.parse(localStorage.getItem('orgData'))
        const orgId = orgData?.id
        const formId = category?._id

        let emails = []
        const toField = popOverData.find((item) => item.key === 'to')
        if (toField && toField.value) {
          emails = toField.value
            .split(',')
            .map((e) => e.trim())
            .filter((e) => e)
        }

        if (emails.length === 0) {
          this.$toast.error('Please enter at least one email address')
          this.$set(this.sendingLinks, category._id, false)
          return
        }

        for (const email of emails) {
          const { responseId, _id } = await this.submitForm(formId, orgId, dummyQuestionRes)
          console.log({ responseId })

          const payload = {
            formTitle: category?.categoryName,
            organizationName: orgData?.name
          }

          const metaData = {
            to: [],
            subject: '',
            messageBody: '',
            reminderMails: [],
            expiry: 1
          }

          popOverData.forEach((item) => {
            let value = item.value

            if (item.key === 'to') {
              value = email
              metaData.to = [email]
              payload[item.key] = email
            } else if (item.key === 'messageBody' && responseId) {
              const linkToReplace = `${APP_URL[process.env.VUE_APP_ENV]}/open/form/${orgId}`
              const newLinkWithQuery = `${linkToReplace}?responseId=${responseId}`
              value = value
                .split('[LINK]')
                .join(`<a href="${newLinkWithQuery}">${newLinkWithQuery}</a>`)
              metaData.messageBody = value
              payload[item.key] = value
            } else {
              payload[item.key] = value

              if (item.key === 'subject') metaData.subject = value
              if (item.key === 'reminderMails') {
                metaData.reminderMails = value ? value.split(',').map((email) => email.trim()) : []
              }
              if (item.key === 'expiry') metaData.expiry = value
            }
          })

          if (responseId) {
            await this.$axios.put(`/orgSetup/form-response/${_id}`, { metaData })
          }

          await this.$axios.post('/orgSetup/send-form-link', payload)
        }

        this.$toast.success('Link(s) sent successfully!')
        const popoverRef = `popoverMenu_${category._id}`
        if (this.$refs[popoverRef] && this.$refs[popoverRef][0]) {
          this.$refs[popoverRef][0].closePopover()
        }
      } catch (error) {
        console.log(error)
        this.$toast.error('Failed to send link(s)')
      } finally {
        this.$set(this.sendingLinks, category._id, false)
      }
    },
    openPopoverMenu(catId, event) {
      event.stopPropagation()
      const popoverRef = `popoverMenu_${catId}`
      this.$nextTick(() => {
        if (this.$refs[popoverRef] && this.$refs[popoverRef][0]) {
          this.$refs[popoverRef][0].open()
        }
      })
    },
    copySpecificCategoryLink(categoryId, categoryName) {
      if (categoryId) {
        const link = `${APP_URL[process.env.VUE_APP_ENV]}/open/form/${
          this.orgData?.id
        }/${categoryId}`

        navigator.clipboard
          .writeText(link)
          .then(() => {
            this.$toast.success(`Link for "${categoryName}" copied to clipboard!`)
            this.showCategoryMenu = false
          })
          .catch((err) => {
            console.error('Failed to copy link: ', err)
            this.$toast.error('Failed to copy link to clipboard')
          })
        return link
      } else {
        this.$toast.warning(
          `Category "${categoryName}" doesn't have an ID yet. Save the questionnaire first.`
        )
      }
    },
    copyFormId(formId) {
      navigator.clipboard
        .writeText(formId)
        .then(() => {
          this.$toast.success(`FormId copied to clipboard!`)
          this.showCategoryMenu = false
        })
        .catch((err) => {
          console.error('Failed to copy link: ', err)
          this.$toast.error('Failed to copy link to clipboard')
        })
    },
    removeOption(index) {
      this.options.splice(index, 1)
    },
    addOption() {
      if (this.newOption && this.newOption.trim() !== '') {
        this.options.push(this.newOption.trim())
        this.newOption = ''
      }
    },
    async handleImageUpload(event, type) {
      const file = event.target.files[0]
      if (!file) return

      const formData = new FormData()
      formData.append('attachments', file)
      formData.append('type', type)
      formData.append('formId', this.editCategoryId)

      try {
        const response = await this.$axios.post('/org/logo', formData)

        if (response.data.success && response.data.url) {
          this.$set(this.categoryImages, type, {
            type: type,
            path: response.data.url.doc_physical_path,
            preview: URL.createObjectURL(file),
            name: file.name
          })
          this.$toast.success(
            `${type.charAt(0).toUpperCase() + type.slice(1)} uploaded successfully!`
          )
        } else {
          this.$toast.error('Failed to upload image')
        }
      } catch (error) {
        console.error('Error uploading image:', error)
        this.$toast.error('Error uploading image')
      }
    },
    triggerFileInput(type) {
      if (type === 'logo') {
        this.$refs.logoInput.click()
      } else if (type === 'banner') {
        this.$refs.bannerInput.click()
      } else if (type === 'paymentQR') {
        this.$refs.paymentQRInput.click()
      }
    },
    removeImage(type) {
      this.$set(this.categoryImages, type, null)
    },
    addCategory() {
      this.resetCategoryForm()
      this.editingCategoryName = null
      // Reset stepper values
      this.categoryStep = 1
      this.linkWithSubLicense = false
      this.collectDataBasedOnCategory = false
      this.triggerNotifications = false
      this.showAddCategoryModal = true
    },
    async handlePaymentQRUpload(event) {
      const file = event.target.files[0]
      if (!file) return

      const formData = new FormData()
      formData.append('attachments', file)
      formData.append('type', 'payment_qr')

      // If editing a question, include the question ID
      if (this.editingQuestionId) {
        formData.append('questionId', this.editingQuestionId)
      }

      try {
        const response = await this.$axios.post('/org/logo', formData)

        if (response.data.success && response.data.url) {
          this.paymentQRImage = {
            path: response.data.url.doc_physical_path,
            preview: URL.createObjectURL(file),
            name: file.name
          }
          this.$toast.success('Payment QR code uploaded successfully!')
        } else {
          this.$toast.error('Failed to upload QR code')
        }
      } catch (error) {
        console.error('Error uploading QR code:', error)
        this.$toast.error('Error uploading QR code')
      }
    },
    removePaymentQR() {
      this.paymentQRImage = null
    },
    addPaymentPlan() {
      this.paymentPlans.push({
        planName: '',
        planDescription: '',
        planDuration: 0,
        planAmount: 0
      })
    },
    removePaymentPlan(index) {
      this.paymentPlans.splice(index, 1)
    },
    async updateQuestionOrder(param1, param2) {
      // Handle both regular questions and section questions based on parameters
      // If only one parameter, it's for regular questions
      // If two parameters, first is sectionIndex and second is newOrder (for sections)
      if (arguments.length === 1) {
        // Regular question reordering
        const newOrder = param1
        if (!this.selectedCategory) return

        try {
          this.isLoading = true

          // Prepare category data for API call
          const categoryData = {
            isPrivate: this.selectedCategory.isPrivate,
            categoryName: this.selectedCategory.categoryName,
            header: this.selectedCategory.header || '',
            images: this.selectedCategory.images || [],
            questions: newOrder,
            subCase: this.selectedCategory?.subCase || undefined,
            dataCategory: this.selectedCategory.dataCategory || null,
            enabledNotifications: this.selectedCategory.enabledNotifications || null
          }

          // Make API call to update category with new question order
          const response = await this.$axios.put(
            `/orgSetup/dynamic-form/${this.selectedCategory._id}`,
            categoryData
          )

          // Update local data
          const updatedCategory = response.data.data || categoryData
          const categoryIndex = this.questionnaire.findIndex(
            (cat) => cat._id === this.selectedCategory._id
          )
          if (categoryIndex !== -1) {
            this.$set(this.questionnaire, categoryIndex, updatedCategory)
          }

          this.$toast.success('Question order updated successfully!')
        } catch (error) {
          console.error('Error updating question order:', error)
          this.$toast.error('Failed to update question order')
        } finally {
          this.isLoading = false
        }
      } else {
        // Section question reordering
        const sectionIndex = param1
        const newOrder = param2

        if (
          !this.selectedCategory ||
          !this.selectedCategory.sections ||
          !this.selectedCategory.sections[sectionIndex]
        )
          return

        try {
          this.isLoading = true

          // Create a copy of the category with updated section questions
          const updatedCategory = { ...this.selectedCategory }
          const updatedSections = [...updatedCategory.sections]
          updatedSections[sectionIndex] = {
            ...updatedSections[sectionIndex],
            questions: newOrder
          }
          updatedCategory.sections = updatedSections

          // Prepare category data for API call
          const categoryData = {
            isPrivate: updatedCategory.isPrivate,
            categoryName: updatedCategory.categoryName,
            header: updatedCategory.header || '',
            images: updatedCategory.images || [],
            questions: updatedCategory.questions || [],
            sections: updatedCategory.sections,
            subCase: updatedCategory.subCase || undefined,
            dataCategory: updatedCategory.dataCategory || null,
            enabledNotifications: updatedCategory.enabledNotifications || null
          }

          // Make API call to update category with new section question order
          const response = await this.$axios.put(
            `/orgSetup/dynamic-form/${updatedCategory._id}`,
            categoryData
          )

          // Update local data
          const updatedCategoryFromServer = response.data.data || categoryData
          const categoryIndex = this.questionnaire.findIndex(
            (cat) => cat._id === updatedCategory._id
          )
          if (categoryIndex !== -1) {
            this.$set(this.questionnaire, categoryIndex, updatedCategoryFromServer)
          }

          this.$toast.success('Question order updated successfully!')
        } catch (error) {
          console.error('Error updating section question order:', error)
          this.$toast.error('Failed to update question order')
        } finally {
          this.isLoading = false
        }
      }
    },
    getCategoryBannerImage(category) {
      if (!category.images) return null
      const banner = category.images.find((img) => img.type === 'banner')
      return banner ? this.bannerLogoUrl(banner.path) : null
    },
    getCategoryLogoImage(category) {
      if (!category.images) return null
      const logo = category.images.find((img) => img.type === 'logo')
      return logo ? this.bannerLogoUrl(logo.path) : null
    },
    resetQuestionCollectionKeyFields() {
      if (this.selectedCategory && this.selectedCategory.questions) {
        this.linkedKey = null
        this.subcaseChangeinfo = true
        this.fetchDataCategories()
      }
    },
    async fetchDataCategories() {
      if (!this.selectedSubcase) return

      try {
        // Find the subcase in the available subcases
        const subCase = this.subCases[0]?.subCase?.find(
          (subCase) => subCase.name === this.selectedSubcase
        )

        if (subCase && subCase.dataCategories) {
          this.dataCategories = subCase.dataCategories.map((cat) => ({
            text: cat.name,
            value: cat._id
          }))
        } else {
          this.dataCategories = []
        }
      } catch (error) {
        console.error('Error fetching data categories:', error)
        this.$toast.error('Failed to load data categories')
        this.dataCategories = []
      }
    },
    async getwhatsappTriggers() {
      try {
        const response = await this.$axios.get('/whatsapp/templates/assign')
        this.whatsappTriggers = response.data.templates || []
      } catch (error) {
        console.error('Error fetching whatsapp templates:', error)
        this.$toast.error('Failed to load whatsapp templates')
      }
    },
    async fetchAllTemplates() {
      // Combine all templates with notificationType
      const whatsapp = (this.whatsappTriggers || []).map((t) => ({
        ...t,
        notificationType: 'WHATSAPP'
      }))
      const sms = (this.smsTemplates || []).map((t) => ({ ...t, notificationType: 'SMS' }))
      const email = (this.emailTemplates || []).map((t) => ({ ...t, notificationType: 'EMAIL' }))
      this.allTemplates = [...whatsapp, ...sms, ...email]
    },
    handleLicenseStepComplete() {
      if (this.linkWithSubLicense && !this.selectedSubcase) {
        this.$toast.error('Please select a License/Team')
        return
      }
      if (this.selectedSubcase) {
        this.categoryStep = 3
      } else {
        this.categoryStep = 5
      }
    },
    handleDataCategoryStepComplete() {
      if (this.collectDataBasedOnCategory && !this.selectedDataCategory) {
        this.$toast.error('Please select a Data Category')
        return
      }
      this.categoryStep = 4
    },
    handleAutoFormComplete() {
      if (this.autoCreateDynamicForm && (!this.linkWithSubLicense || !this.selectedSubcase)) {
        this.$toast.error(
          'Auto-create requires a linked License/Team. Please go back and select one.'
        )
        return
      }

      this.categoryStep = 5
    },
    async autoGenerateQuestions(category) {
      if (!this.autoCreateDynamicForm || !this.selectedSubcase || !category) {
        return
      }

      try {
        const subCase = this.subCases[0]?.subCase?.find(
          (subCase) => subCase.name === this.selectedSubcase
        )

        if (!subCase || !subCase.fieldMappings) {
          this.$toast.warning('No field mappings found for the selected License/Team')
          return
        }

        // Generate questions based on field mappings
        const generatedQuestions = []
        Object.entries(subCase.fieldMappings).forEach(([key, value]) => {
          if (value?.displayName) {
            let questionType = 'TEXT'
            let isRequired = false
            let validationMessage = ''

            if (['tenure', 'pos', 'emiAmount'].includes(key)) {
              questionType = 'NUMBER'
            }

            if (['caseNo', 'crn'].includes(key)) {
              isRequired = true
              validationMessage = `${value.displayName} is required`
            }

            const question = {
              question: value.displayName,
              questionType: questionType,
              isRequired: isRequired,
              options: [],
              validationMessage: validationMessage,
              collectionKeyField: key,
              userResponse: null
            }

            generatedQuestions.push(question)
          }
        })

        if (generatedQuestions.length > 0) {
          // Combine existing questions with generated ones
          const updatedQuestions = [...(category.questions || []), ...generatedQuestions]

          // Prepare category data for API call
          const categoryData = {
            isPrivate: category.isPrivate,
            categoryName: category.categoryName,
            header: category.header || '',
            images: category.images || [],
            questions: updatedQuestions,
            subCase: category.subCase || undefined,
            dataCategory: category.dataCategory || null,
            enabledNotifications: category.enabledNotifications || null
          }

          // Make API call to update category with generated questions
          const response = await this.$axios.put(
            `/orgSetup/dynamic-form/${category._id}`,
            categoryData
          )

          // Update local data
          const updatedCategory = response.data.data || categoryData
          const categoryIndex = this.questionnaire.findIndex((cat) => cat._id === category._id)
          if (categoryIndex !== -1) {
            this.$set(this.questionnaire, categoryIndex, updatedCategory)
          }

          this.$toast.success(
            `${generatedQuestions.length} questions auto-generated from field mappings`
          )
        } else {
          this.$toast.warning('No valid field mappings found to generate questions')
        }
      } catch (error) {
        console.error('Error auto-generating questions:', error)
        this.$toast.error('Failed to auto-generate questions')
      }
    },

    // Form connections methods
    showFormConnections(category) {
      this.selectedFormForConnections = category
      this.formConnections = this.getDummyConnections(category.formId)
      this.showConnectionsModal = true
    },

    getConnectionCount(formId) {
      return this.getDummyConnections(formId).length
    },

    getDummyConnections(formId) {
      // Generate dummy connections based on formId
      const allPossibleConnections = [
        {
          id: 'conn_1',
          moduleName: 'Workflow Steps',
          description: 'Form integrated with step-by-step workflow processes for case management',
          icon: 'mdi-workflow',
          iconColor: 'blue',
          connectedDate: '2024-01-15',
          connectedBy: 'John Doe',
          usageCount: 245,
          status: 'active',
          moduleId: 'workflow_steps'
        },
        {
          id: 'conn_2',
          moduleName: 'Case Management',
          description: 'Automatically creates new cases when form is submitted',
          icon: 'mdi-briefcase',
          iconColor: 'green',
          connectedDate: '2024-02-03',
          connectedBy: 'Sarah Wilson',
          usageCount: 189,
          status: 'active',
          moduleId: 'case_management'
        },
        {
          id: 'conn_3',
          moduleName: 'Visit Tracking',
          description: 'Captures location and visit details during field operations',
          icon: 'mdi-map-marker',
          iconColor: 'orange',
          connectedDate: '2024-01-28',
          connectedBy: 'Mike Johnson',
          usageCount: 156,
          status: 'inactive',
          moduleId: 'visit_tracking'
        },
        {
          id: 'conn_4',
          moduleName: 'Employee Onboarding',
          description: 'Used for new employee registration and document collection',
          icon: 'mdi-account-plus',
          iconColor: 'purple',
          connectedDate: '2024-02-10',
          connectedBy: 'Lisa Chen',
          usageCount: 67,
          status: 'active',
          moduleId: 'employee_onboarding'
        },
        {
          id: 'conn_5',
          moduleName: 'Customer Feedback',
          description: 'Collects customer satisfaction and feedback data',
          icon: 'mdi-comment-account',
          iconColor: 'teal',
          connectedDate: '2024-01-20',
          connectedBy: 'David Brown',
          usageCount: 312,
          status: 'active',
          moduleId: 'customer_feedback'
        },
        {
          id: 'conn_6',
          moduleName: 'Audit Checklist',
          description: 'Quality assurance and compliance audit processes',
          icon: 'mdi-clipboard-check',
          iconColor: 'red',
          connectedDate: '2024-02-05',
          connectedBy: 'Emma Davis',
          usageCount: 89,
          status: 'inactive',
          moduleId: 'audit_checklist'
        }
      ]

      // Return random 2-4 connections for each form
      const connectionCount = Math.floor(Math.random() * 3) + 2 // 2-4 connections
      const shuffled = allPossibleConnections.sort(() => 0.5 - Math.random())
      return shuffled.slice(0, connectionCount)
    },

    viewConnectionDetails(connection) {
      this.$toast.info(`Viewing details for ${connection.moduleName}`)
      // Here you would typically navigate to the connection details page
    },

    editConnection(connection) {
      this.$toast.info(`Editing connection to ${connection.moduleName}`)
      // Here you would open an edit modal or navigate to edit page
    },

    async disconnectForm(connection) {
      if (
        !confirm(`Are you sure you want to disconnect this form from ${connection.moduleName}?`)
      ) {
        return
      }

      try {
        // Remove connection from the list
        const index = this.formConnections.findIndex((conn) => conn.id === connection.id)
        if (index !== -1) {
          this.formConnections.splice(index, 1)
        }

        this.$toast.success(`Form disconnected from ${connection.moduleName}`)
      } catch (error) {
        console.error('Error disconnecting form:', error)
        this.$toast.error('Failed to disconnect form')
      }
    },

    async connectFormToModule() {
      if (!this.selectedModuleToConnect) {
        this.$toast.error('Please select a module to connect')
        return
      }

      try {
        const selectedModule = this.availableModules.find(
          (m) => m.id === this.selectedModuleToConnect
        )

        // Create new connection
        const newConnection = {
          id: `conn_${Date.now()}`,
          moduleName: selectedModule.name,
          description: selectedModule.description,
          icon: selectedModule.icon,
          iconColor: selectedModule.iconColor,
          connectedDate: new Date().toISOString().split('T')[0],
          connectedBy: 'Current User', // Replace with actual user
          usageCount: 0,
          status: 'active',
          moduleId: selectedModule.id,
          notes: this.connectionNotes
        }

        this.formConnections.push(newConnection)

        this.$toast.success(`Form connected to ${selectedModule.name}`)
        this.showAddConnectionModal = false
        this.selectedModuleToConnect = null
        this.connectionNotes = ''
      } catch (error) {
        console.error('Error connecting form:', error)
        this.$toast.error('Failed to connect form to module')
      }
    },

    // Copy questions methods
    loadSourceQuestions() {
      if (!this.selectedSourceCategory) {
        this.sourceQuestions = []
        this.selectedQuestions = []
        return
      }

      const sourceCategory = this.questionnaire.find(
        (cat) => cat._id === this.selectedSourceCategory
      )
      if (sourceCategory && sourceCategory.questions) {
        this.sourceQuestions = [...sourceCategory.questions]
      } else {
        this.sourceQuestions = []
      }
      this.selectedQuestions = []
    },

    selectAllQuestions() {
      this.selectedQuestions = [...this.sourceQuestions]
    },

    deselectAllQuestions() {
      this.selectedQuestions = []
    },

    async copySelectedQuestions() {
      if (this.selectedQuestions.length === 0) {
        this.$toast.error('Please select at least one question to copy')
        return
      }

      if (!this.selectedCategory) {
        this.$toast.error('No target form selected')
        return
      }

      try {
        this.isCopyingQuestions = true

        // Prepare questions for copying
        const questionsToAdd = this.selectedQuestions.map((question) => {
          const newQuestion = {
            question: question.question,
            questionType: question.questionType,
            isRequired: this.copyOptions.preserveRequiredFlag ? question.isRequired : false,
            options: question.options ? [...question.options] : [],
            validationMessage: this.copyOptions.preserveValidation
              ? question.validationMessage || ''
              : '',
            userResponse: null
          }

          // Handle field mappings
          if (this.copyOptions.preserveFieldMappings && question.collectionKeyField) {
            // Check if the target form has the same subcase
            const sourceCategory = this.questionnaire.find(
              (cat) => cat._id === this.selectedSourceCategory
            )
            if (sourceCategory && sourceCategory.subCase === this.selectedCategory.subCase) {
              newQuestion.collectionKeyField = question.collectionKeyField
            } else {
              newQuestion.collectionKeyField = null
            }
          } else {
            newQuestion.collectionKeyField = null
          }

          // Handle specific question types
          if (question.questionType === 'LOCAL_ATTACHMENTS' && question.allowedNoOfAttachments) {
            newQuestion.allowedNoOfAttachments = question.allowedNoOfAttachments
          }

          // if (question.questionType === 'SERVICE_PLAN') {
          //   if (question.payment_Plan) {
          //     newQuestion.payment_Plan = [...question.payment_Plan]
          //   }
          //   if (question.paymentLink) {
          //     newQuestion.paymentLink = question.paymentLink
          //   }
          //   if (question.payment_UPI_Id) {
          //     newQuestion.payment_UPI_Id = question.payment_UPI_Id
          //   }
          //   if (question.paymentIntegrationType) {
          //     newQuestion.paymentIntegrationType = question.paymentIntegrationType
          //   }
          // }

          if (question.questionType === 'DATA_CATEGORY') {
            newQuestion.dataCategory = question.dataCategory
          }

          return newQuestion
        })

        // Get current questions and add new ones
        const updatedQuestions = [...(this.selectedCategory.questions || []), ...questionsToAdd]

        // Prepare category data for API call
        const categoryData = {
          isPrivate: this.selectedCategory.isPrivate,
          categoryName: this.selectedCategory.categoryName,
          header: this.selectedCategory.header || '',
          images: this.selectedCategory.images || [],
          questions: updatedQuestions,
          subCase: this.selectedCategory.subCase || undefined,
          dataCategory: this.selectedCategory.dataCategory || null,
          enabledNotifications: this.selectedCategory.enabledNotifications || null
        }

        // Make API call to update category with copied questions
        const response = await this.$axios.put(
          `/orgSetup/dynamic-form/${this.selectedCategory._id}`,
          categoryData
        )

        // Update local data
        const updatedCategory = response.data.data || categoryData
        const categoryIndex = this.questionnaire.findIndex(
          (cat) => cat._id === this.selectedCategory._id
        )
        if (categoryIndex !== -1) {
          this.$set(this.questionnaire, categoryIndex, updatedCategory)
        }

        this.$toast.success(
          `${questionsToAdd.length} question${
            questionsToAdd.length !== 1 ? 's' : ''
          } copied successfully!`
        )

        // Close modal and reset state
        this.showCopyQuestionsModal = false
        this.selectedSourceCategory = null
        this.sourceQuestions = []
        this.selectedQuestions = []
      } catch (error) {
        console.error('Error copying questions:', error)
        this.$toast.error('Failed to copy questions')
      } finally {
        this.isCopyingQuestions = false
      }
    },

    // Load more categories method
    async loadMoreCategories() {
      if (this.canLoadMore && !this.isLoadingMore) {
        await this.fetchCategories(this.currentPage + 1, true)
      }
    },
    async fetchStaticUseCaseData() {
      try {
        const response = await this.$axios.get('/orgSetup/loan-management-field-mapping/data')
        const dataKeys = Object.keys(response.data.data)
        this.useCases = dataKeys.map((el) => {
          return {
            text: convertToTitleCase(el),
            value: el
          }
        })
      } catch (error) {
        console.error('Error fetching static loan data:', error)
      }
    },
    async fetchExtendUseCaseData() {
      try {
        if (!this.selectedUseCase) return
        const response = await this.$axios.get(
          `/orgSetup/extend-usecase?useCase=${this.selectedUseCase}`
        )
        // console.log(response.data.data)
        this.allSubCases = response.data?.data
      } catch (error) {
        console.error('Error fetching static loan data:', error)
      }
    },
    async fetchExtendUseCaseMapping(id) {
      try {
        if (!id) return
        const response = await this.$axios.get(`/orgSetup/extend-usecase/${id}`)
        this.subCaseMapping = response.data?.data
      } catch (error) {
        console.error('Error fetching static loan data:', error)
      }
    },

    selectPredefinedSection(section) {
      this.selectedPredefinedSection = section
      // Pass existing questions to the PredefinedFormBuilder
      this.existingQuestionsForPredefinedForm = this.selectedCategory?.questions || []
      this.showPredefinedSectionDialog = true
    },
    handlePredefinedQuestionsSaved(questions) {
      // Add the selected predefined questions to the expanded form
      if (this.selectedCategory && questions && questions.length > 0) {
        // Map the predefined questions structure to the format expected by the form
        // const questionsToAdd = questions.flatMap((section) =>
        //   section.questions.map((question) => ({
        //     question: question.question,
        //     questionType: question.questionType,
        //     isRequired: question.isRequired,
        //     options: question.options || [],
        //     validationMessage: question.validationMessage || '',
        //     userResponse: null
        //   }))
        // )
        this.addQuestionsToCategory(questions)
      }
      this.showPredefinedSectionDialog = false
    },
    // New method to get existing questions in the proper format for PredefinedFormBuilder
    getExistingQuestionsForPredefinedForm() {
      // This method is not needed as we're passing the actual questions structure
      return []
    },

    // New method to get the text for the selected predefined section
    getSelectedPredefinedSectionText() {
      if (!this.selectedSpecialCategory) return ''
      const selected = this.specialCategories.find(
        (category) => category.value === this.selectedSpecialCategory
      )
      return selected ? selected.text : this.selectedSpecialCategory
    },

    // New method to add questions to a category
    async addQuestionsToCategory(questionsToAdd) {
      if (!this.selectedCategory || !questionsToAdd || questionsToAdd.length === 0) {
        return
      }

      try {
        // Separate existing regular questions (without sections) from section-based questions
        const existingRegularQuestions = (this.selectedCategory.questions || []).filter(
          (question) => !question.sectionName
        )

        // The questionsToAdd from PredefinedFormBuilder are only section-based questions
        // Combine existing regular questions with new section-based questions
        const updatedQuestions = [...existingRegularQuestions, ...questionsToAdd]

        // Prepare category data for API call
        const categoryData = {
          isPrivate: this.selectedCategory.isPrivate,
          categoryName: this.selectedCategory.categoryName,
          header: this.selectedCategory.header || '',
          images: this.selectedCategory.images || [],
          questions: updatedQuestions,
          subCase: this.selectedCategory.subCase || undefined,
          dataCategory: this.selectedCategory.dataCategory || null,
          enabledNotifications: this.selectedCategory.enabledNotifications || null
        }

        // Make API call to update category with new questions
        const response = await this.$axios.put(
          `/orgSetup/dynamic-form/${this.selectedCategory._id}`,
          categoryData
        )

        // Update local data
        const updatedCategory = response.data.data || categoryData
        const categoryIndex = this.questionnaire.findIndex(
          (cat) => cat._id === this.selectedCategory._id
        )

        if (categoryIndex !== -1) {
          this.$set(this.questionnaire, categoryIndex, updatedCategory)

          // Also update the expanded category if it's the same
          if (this.expandedCategory === categoryIndex) {
            this.expandedCategory = categoryIndex
          }
        }

        this.$toast.success(
          `${questionsToAdd.length} question${
            questionsToAdd.length !== 1 ? 's' : ''
          } updated successfully!`
        )
      } catch (error) {
        console.error('Error updating questions:', error)
        this.$toast.error('Failed to update questions')
      }
    },
    async fetchPredefinedKeys() {
      try {
        const response = await this.$axios.get(`/orgSetup/predefined-special-category`)
        const data = response.data?.data
        this.specialCategories = data || []
      } catch (error) {
        console.log(error)
      }
    }
  },
  async mounted() {
    await this.getwhatsappTriggers()
    await this.fetchStaticUseCaseData()
    await this.fetchPredefinedKeys()
    await this.fetchDepartments()
    // await this.fetchDesignationsByDepartment(this.selectedDepartment)
  }
}
</script>

<!-- Add CSS for the selected category and banner/logo styling -->
<style scoped>
/* Custom styles */
.question-card {
  transition: all 0.3s ease;
}
.question-card:hover {
  /* transform: translateY(-2px); */
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}
.question-type-selector {
  transition: all 0.2s ease;
}
.question-type-selector:hover {
  background-color: #f0f9ff;
  border-color: #3b82f6;
}
.drag-handle {
  cursor: move;
}
.preview-container {
  /* min-height: 200px; */
  /* border: 2px dashed #e5e7eb; */
  transition: all 0.3s ease;
}
.preview-container:hover {
  border-color: #3b82f6;
}
.selected-category {
  border: 2px solid #21427d !important;
}
.banner-container {
  position: relative;
  width: 100%;
  margin-bottom: 1rem;
}

/* Custom styling for stepper completed steps */
::v-deep .v-stepper__step--complete .v-stepper__step__step {
  background-color: #4caf50 !important; /* Green color for completed steps */
}

::v-deep .v-stepper__step--complete .v-stepper__label {
  color: #4caf50 !important; /* Green color for completed step labels */
}

::v-deep .v-stepper__step--active .v-stepper__step__step {
  background-color: #1976d2 !important; /* Keep active step blue */
}

/* Connection modal styles */
.connection-card {
  transition: all 0.3s ease;
}

.connection-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.connection-status-active {
  background: linear-gradient(45deg, #4caf50, #66bb6a);
}

.connection-status-inactive {
  background: linear-gradient(45deg, #ff9800, #ffb74d);
}

/* Module selection styling */
::v-deep .v-select__selection {
  display: flex;
  align-items: center;
}

/* Connection button hover effects */
.connection-action-btn {
  transition: all 0.2s ease;
}

.connection-action-btn:hover {
  transform: scale(1.05);
}
.form-title {
  font-size: 1.25rem;
  padding: 0px !important;
  font-weight: 600;
  color: #21427d;
  margin: 0;
}

/* Connection badge styling */
.connection-badge {
  min-width: 18px !important;
  height: 18px !important;
  font-size: 10px !important;
  font-weight: bold !important;
}
.v-card__subtitle,
.v-card__text,
.v-card__title {
  padding: 0px !important;
}
.v-dialog {
  overflow-y: hidden !important;
}
::v-deep(.v-dialog:not(.v-dialog--fullscreen)) {
  max-height: none !important;
}
.v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap {
  padding: 0 !important;
}
.coloms {
  padding-top: 0px !important;
}
</style>
